/**
 * Slug UI v0.17.7
 * @author hardylin<hardylin@tencent.com>
 */
import Vue from 'vue';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ":root{--safe-area-inset-top:44px;--safe-area-inset-right:44px;--safe-area-inset-bottom:21px;--safe-area-inset-left:44px}";
styleInject(css,{"insertAt":"top"});

var css$1 = ".sui-style--ellipsis-2,.sui-style--ellipsis-3,.sui-style--ellipsis-4{display:-webkit-box;-webkit-box-orient:vertical;text-overflow:ellipsis;overflow:hidden}.sui-style--ellipsis-2{-webkit-line-clamp:2}.sui-style--ellipsis-3{-webkit-line-clamp:3}.sui-style--ellipsis-4{-webkit-line-clamp:4}";
styleInject(css$1,{"insertAt":"top"});

var css$2 = ".sui-animation--fade-enter-to,.sui-animation--fade-leave-to{transition:opacity .3s ease-in-out}.sui-animation--fade-enter,.sui-animation--fade-leave-to{opacity:0}.sui-animation--fade-fast-enter-to,.sui-animation--fade-fast-leave-to{transition:opacity .2s}.sui-animation--fade-fast-enter,.sui-animation--fade-fast-leave-to{opacity:0}.sui-animation--slide-enter,.sui-animation--slide-leave-to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}.sui-animation--slide-enter-to,.sui-animation--slide-leave-to{transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.sui-animation--slide-fast-enter,.sui-animation--slide-fast-leave-to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}.sui-animation--slide-fast-enter-to,.sui-animation--slide-fast-leave-to{transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out}";
styleInject(css$2,{"insertAt":"top"});

var version = "0.17.7";

/**
 * @file 全局配置
 * @author hardylin <hardylin@tencent.com>
 */
var config = {
  // 主题色
  colors: {
    1: '#1c1c1c',
    2: '#555555',
    3: '#aaaaaa',
    4: '#4c84ff',
    5: '#4c84ff',
    6: '#f2f2f2',
    7: '#ffffff',
    8: '#e1e1e1',
    9: '#ffffff',
    10: '#f2f2f2',
    11: '#fb4855',
    12: '#ff9f01',
    13: '#3ec16c',
    14: '#4c84ff',
    15: '#888888',
    16: '#ffffff',
    17: '#e0e0e0',
    18: '#f2f2f2',
    19: '#bbbbbb',
    20: '#1c1c1c'
  }
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
}; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


var global_1 = // eslint-disable-next-line no-undef
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func
Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var descriptors = !fails(function () {
  return Object.defineProperty({}, 'a', {
    get: function () {
      return 7;
    }
  }).a != 7;
});

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1 = global_1.document; // typeof document.createElement is 'object' in old IE

var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  }

  return it;
};

// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string

var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty = Object.defineProperty; // `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty

var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) {
    /* empty */
  }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var objectDefineProperty = {
  f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }

  return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});
var sharedStore = store;

var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.4.2',
    mode:  'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
});

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var useSymbolAsUid = nativeSymbol // eslint-disable-next-line no-undef
&& !Symbol.sham // eslint-disable-next-line no-undef
&& typeof Symbol() == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  }

  return WellKnownSymbolsStore[name];
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
var toStringTagSupport = String(test) === '[object z]';

var functionToString = shared('native-function-to-string', Function.toString);

var WeakMap = global_1.WeakMap;
var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(functionToString.call(WeakMap));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;

    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    }

    return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;

  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };

  get = function (it) {
    return wmget.call(store$1, it) || {};
  };

  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;

  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };

  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };

  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(functionToString).split('toString');
  shared('inspectSource', function (it) {
    return functionToString.call(it);
  });
  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;

    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
      enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }

    if (O === global_1) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }

    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
  });
});

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag'); // ES3 wrong here

var CORRECT_ARGUMENTS = classofRaw(function () {
  return arguments;
}()) == 'Arguments'; // fallback for IE11 Script Access Denied error

var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
}; // getting tag from ES6+ `Object.prototype.toString`


var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
  : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
  : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// https://tc39.github.io/ecma262/#sec-object.prototype.tostring


var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// https://tc39.github.io/ecma262/#sec-object.prototype.tostring

if (!toStringTagSupport) {
  redefine(Object.prototype, 'toString', objectToString, {
    unsafe: true
  });
}

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
  1: 2
}, 1); // `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable

var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;
var objectPropertyIsEnumerable = {
  f: f$1
};

var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor

var f$2 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) {
    /* empty */
  }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
  f: f$2
};

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor; // `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger

var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min; // `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength

var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min; // Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value; // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare

    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++]; // eslint-disable-next-line no-self-compare

      if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key); // Don't enum bug & hidden keys


  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }

  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames

var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
  f: f$3
};

var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
  f: f$4
};

var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/

var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;

  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }

  if (target) for (key in source) {
    sourceProperty = source[key];

    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];

    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    } // add a flag to not completely full polyfills


    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    } // extend global


    redefine(target, key, sourceProperty, options);
  }
};

var nativePromiseConstructor = global_1.Promise;

var redefineAll = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);

  return target;
};

var defineProperty = objectDefineProperty.f;
var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$2)) {
    defineProperty(it, TO_STRING_TAG$2, {
      configurable: true,
      value: TAG
    });
  }
};

var SPECIES = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  }

  return it;
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  }

  return it;
};

var iterators = {};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype; // check on default Array iterator

var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

var bindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;

  switch (length) {
    case 0:
      return function () {
        return fn.call(that);
      };

    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function ()
  /* ...args */
  {
    return fn.apply(that, arguments);
  };
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$1] || it['@@iterator'] || iterators[classof(it)];
};

var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1 = createCommonjsModule(function (module) {
  var Result = function (stopped, result) {
    this.stopped = stopped;
    this.result = result;
  };

  var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
    var boundFunction = bindContext(fn, that, AS_ENTRIES ? 2 : 1);
    var iterator, iterFn, index, length, result, next, step;

    if (IS_ITERATOR) {
      iterator = iterable;
    } else {
      iterFn = getIteratorMethod(iterable);
      if (typeof iterFn != 'function') throw TypeError('Target is not iterable'); // optimisation for array iterators

      if (isArrayIteratorMethod(iterFn)) {
        for (index = 0, length = toLength(iterable.length); length > index; index++) {
          result = AS_ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
          if (result && result instanceof Result) return result;
        }

        return new Result(false);
      }

      iterator = iterFn.call(iterable);
    }

    next = iterator.next;

    while (!(step = next.call(iterator)).done) {
      result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
      if (typeof result == 'object' && result && result instanceof Result) return result;
    }

    return new Result(false);
  };

  iterate.stop = function (result) {
    return new Result(true, result);
  };
});

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return {
        done: !!called++
      };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };

  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  }; // eslint-disable-next-line no-throw-literal


  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;

  try {
    var object = {};

    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };

    exec(object);
  } catch (error) {
    /* empty */
  }

  return ITERATION_SUPPORT;
};

var SPECIES$1 = wellKnownSymbol('species'); // `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor

var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$1]) == undefined ? defaultConstructor : aFunction$1(S);
};

var html = getBuiltIn('document', 'documentElement');

var userAgent = getBuiltIn('navigator', 'userAgent') || '';

var isIos = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);

var location = global_1.location;
var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + '', location.protocol + '//' + location.host);
}; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;

    while (arguments.length > i) args.push(arguments[i++]);

    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };

    defer(counter);
    return counter;
  };

  clear = function clearImmediate(id) {
    delete queue[id];
  }; // Node.js 0.8-


  if (classofRaw(process) == 'process') {
    defer = function (id) {
      process.nextTick(runner(id));
    }; // Sphere (JS game engine) Dispatch API

  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    }; // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624

  } else if (MessageChannel && !isIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bindContext(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1.addEventListener && typeof postMessage == 'function' && !global_1.importScripts && !fails(post)) {
    defer = post;
    global_1.addEventListener('message', listener, false); // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    }; // Rest old browsers

  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask = task.set;
var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var process$1 = global_1.process;
var Promise$1 = global_1.Promise;
var IS_NODE = classofRaw(process$1) == 'process'; // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`

var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify, toggle, node, promise, then; // modern engines have queueMicrotask method

if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process$1.domain)) parent.exit();

    while (head) {
      fn = head.fn;
      head = head.next;

      try {
        fn();
      } catch (error) {
        if (head) notify();else last = undefined;
        throw error;
      }
    }

    last = undefined;
    if (parent) parent.enter();
  }; // Node.js


  if (IS_NODE) {
    notify = function () {
      process$1.nextTick(flush);
    }; // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339

  } else if (MutationObserver && !isIos) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, {
      characterData: true
    });

    notify = function () {
      node.data = toggle = !toggle;
    }; // environments with maybe non-completely correct, but existent Promise

  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;

    notify = function () {
      then.call(promise, flush);
    }; // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout

  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = {
    fn: fn,
    next: undefined
  };
  if (last) last.next = task;

  if (!head) {
    head = task;
    notify();
  }

  last = task;
};

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
}; // 25.4.1.5 NewPromiseCapability(C)


var f$5 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
  f: f$5
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;

  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};

var process$2 = global_1.process;
var versions = process$2 && process$2.versions;
var v8 = versions && versions.v8;
var match, version$1;

if (v8) {
  match = v8.split('.');
  version$1 = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);

  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version$1 = match[1];
  }
}

var v8Version = version$1 && +version$1;

var task$1 = task.set;
var SPECIES$2 = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = internalState.get;
var setInternalState = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = nativePromiseConstructor;
var TypeError$1 = global_1.TypeError;
var document$2 = global_1.document;
var process$3 = global_1.process;
var inspectSource = shared('inspectSource');
var $fetch = getBuiltIn('fetch');
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var IS_NODE$1 = classofRaw(process$3) == 'process';
var DISPATCH_EVENT = !!(document$2 && document$2.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
var FORCED = isForced_1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);

  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (v8Version === 66) return true; // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test

    if (!IS_NODE$1 && typeof PromiseRejectionEvent != 'function') return true;
  } // We need Promise#finally in the pure version for preventing prototype pollution
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679

  if (v8Version >= 51 && /native code/.test(PromiseConstructor)) return false; // Detect correctness of subclassing with @@species support

  var promise = PromiseConstructor.resolve(1);

  var FakePromise = function (exec) {
    exec(function () {
      /* empty */
    }, function () {
      /* empty */
    });
  };

  var constructor = promise.constructor = {};
  constructor[SPECIES$2] = FakePromise;
  return !(promise.then(function () {
    /* empty */
  }) instanceof FakePromise);
});
var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () {
    /* empty */
  });
}); // helpers

var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0; // variable length - can't use forEach

    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;

      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }

          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // can throw

            if (domain) {
              domain.exit();
              exited = true;
            }
          }

          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }

    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;

  if (DISPATCH_EVENT) {
    event = document$2.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };

  if (handler = global_1['on' + name]) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;

    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    if (IS_NODE$1) {
      process$3.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;

  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);

    if (then) {
      microtask(function () {
        var wrapper = {
          done: false
        };

        try {
          then.call(value, bind(internalResolve, promise, wrapper, state), bind(internalReject, promise, wrapper, state));
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, {
      done: false
    }, error, state);
  }
}; // constructor polyfill


if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState(this);

    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  }; // eslint-disable-next-line no-unused-vars


  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process$3.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };

  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };

  if ( typeof nativePromiseConstructor == 'function') {
    nativeThen = nativePromiseConstructor.prototype.then; // wrap native Promise#then for native async functions

    redefine(nativePromiseConstructor.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected); // https://github.com/zloirock/core-js/issues/640
    }, {
      unsafe: true
    }); // wrap fetch result

    if (typeof $fetch == 'function') _export({
      global: true,
      enumerable: true,
      forced: true
    }, {
      // eslint-disable-next-line no-unused-vars
      fetch: function fetch(input
      /* , init */
      ) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global_1, arguments));
      }
    });
  }
}

_export({
  global: true,
  wrap: true,
  forced: FORCED
}, {
  Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);
PromiseWrapper = getBuiltIn(PROMISE); // statics

_export({
  target: PROMISE,
  stat: true,
  forced: FORCED
}, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});
_export({
  target: PROMISE,
  stat: true,
  forced:  FORCED
}, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});
_export({
  target: PROMISE,
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate_1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags


var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];
var NOT_GENERIC = fails(function () {
  return nativeToString.call({
    source: 'a',
    flags: 'b'
  }) != '/a/b';
}); // FF44- RegExp#toString has a wrong name

var INCORRECT_NAME = nativeToString.name != TO_STRING; // `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring

if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, {
    unsafe: true
  });
}

// https://tc39.github.io/ecma262/#sec-isarray

var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

// https://tc39.github.io/ecma262/#sec-toobject

var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
};

var SPECIES$3 = wellKnownSymbol('species'); // `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate

var arraySpeciesCreate = function (originalArray, length) {
  var C;

  if (isArray(originalArray)) {
    C = originalArray.constructor; // cross-realm fallback

    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
      C = C[SPECIES$3];
      if (C === null) C = undefined;
    }
  }

  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var SPECIES$4 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return v8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};

    constructor[SPECIES$4] = function () {
      return {
        foo: 1
      };
    };

    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679

var IS_CONCAT_SPREADABLE_SUPPORT = v8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species

_export({
  target: 'Array',
  proto: true,
  forced: FORCED$1
}, {
  concat: function concat(arg) {
    // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;

    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];

      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }

    A.length = n;
    return A;
  }
});

// https://tc39.github.io/ecma262/#sec-object.keys

var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// https://tc39.github.io/ecma262/#sec-object.defineproperties

var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;

  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);

  return O;
};

var IE_PROTO = sharedKey('IE_PROTO');
var PROTOTYPE = 'prototype';

var Empty = function () {
  /* empty */
}; // Create object with fake `null` prototype: use iframe Object with cleared prototype


var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;

  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];

  return createDict();
}; // `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create


var objectCreate = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

    result[IE_PROTO] = O;
  } else result = createDict();

  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype$1 = Array.prototype; // Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  createNonEnumerableProperty(ArrayPrototype$1, UNSCOPABLES, objectCreate(null));
} // add a key to Array.prototype[@@unscopables]


var addToUnscopables = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var $includes = arrayIncludes.includes; // `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes

_export({
  target: 'Array',
  proto: true
}, {
  includes: function includes(el
  /* , fromIndex = 0 */
  ) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
}); // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('includes');

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  }

  return it;
};

// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.

/* eslint-disable no-proto */

var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;

  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {
    /* empty */
  }

  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if ( // it can work only with native `setPrototypeOf`
  objectSetPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var defineProperty$1 = objectDefineProperty.f;
var trim = stringTrim.trim;
var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype; // Opera ~12 has broken Object#toString

var BROKEN_CLASSOF = classofRaw(objectCreate(NumberPrototype)) == NUMBER; // `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber

var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;

  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);

    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0b[01]+$/i

        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        // fast equal of /^0o[0-7]+$/i

        default:
          return +it;
      }

      digits = it.slice(2);
      length = digits.length;

      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index); // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols

        if (code < 48 || code > maxCode) return NaN;
      }

      return parseInt(digits, radix);
    }
  }

  return +it;
}; // `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor


if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper // check on 1..constructor(foo) case
    && (BROKEN_CLASSOF ? fails(function () {
      NumberPrototype.valueOf.call(dummy);
    }) : classofRaw(dummy) != NUMBER) ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };

  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : ( // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES2015 (in case, if modules with ES2015 Number statics required before):
  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys$1.length > j; j++) {
    if (has(NativeNumber, key = keys$1[j]) && !has(NumberWrapper, key)) {
      defineProperty$1(NumberWrapper, key, getOwnPropertyDescriptor$3(NativeNumber, key));
    }
  }

  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global_1, NUMBER, NumberWrapper);
}

var floor$1 = Math.floor; // `Number.isInteger` method implementation
// https://tc39.github.io/ecma262/#sec-number.isinteger

var isInteger = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor$1(it) === it;
};

// https://tc39.github.io/ecma262/#sec-number.isinteger

_export({
  target: 'Number',
  stat: true
}, {
  isInteger: isInteger
});

var trim$1 = stringTrim.trim;
var nativeParseInt = global_1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED$2 = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22; // `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix

var _parseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim$1(String(string));
  return nativeParseInt(S, radix >>> 0 || (hex.test(S) ? 16 : 10));
} : nativeParseInt;

// https://tc39.github.io/ecma262/#sec-number.parseint

_export({
  target: 'Number',
  stat: true,
  forced: Number.parseInt != _parseInt
}, {
  parseInt: _parseInt
});

var nativeAssign = Object.assign; // `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
// should work with symbols and should have deterministic property order (V8 bug)

var objectAssign = !nativeAssign || fails(function () {
  var A = {};
  var B = {}; // eslint-disable-next-line no-undef

  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;

  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : nativeAssign;

// https://tc39.github.io/ecma262/#sec-object.assign

_export({
  target: 'Object',
  stat: true,
  forced: Object.assign !== objectAssign
}, {
  assign: objectAssign
});

var MATCH = wellKnownSymbol('match'); // `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp

var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  }

  return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;

  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) {
      /* empty */
    }
  }

  return false;
};

// https://tc39.github.io/ecma262/#sec-string.prototype.includes


_export({
  target: 'String',
  proto: true,
  forced: !correctIsRegexpLogic('includes')
}, {
  includes: function includes(searchString
  /* , position = 0 */
  ) {
    return !!~String(requireObjectCoercible(this)).indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var nativeExec = RegExp.prototype.exec; // This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.

var nativeReplace = String.prototype.replace;
var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}(); // nonparticipating capturing group, copied from es5-shim's String#split patch.


var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }

    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }

    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

var SPECIES$5 = wellKnownSymbol('species');
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;

  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  };

  return ''.replace(re, '$<a>') !== '7';
}); // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;

  re.exec = function () {
    return originalExec.apply(this, arguments);
  };

  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);
  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};

    O[SYMBOL] = function () {
      return 7;
    };

    return ''[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {}; // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.

      re.constructor = {};

      re.constructor[SPECIES$5] = function () {
        return re;
      };

      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: nativeRegExpMethod.call(regexp, str, arg2)
          };
        }

        return {
          done: true,
          value: nativeMethod.call(str, regexp, arg2)
        };
      }

      return {
        done: false
      };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];
    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return regexMethod.call(string, this, arg);
    } // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return regexMethod.call(string, this);
    });
    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt = stringMultibyte.charAt; // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex

var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// https://tc39.github.io/ecma262/#sec-regexpexec

var regexpExecAbstract = function (R, S) {
  var exec = R.exec;

  if (typeof exec === 'function') {
    var result = exec.call(R, S);

    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }

    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$1 = Math.max;
var min$2 = Math.min;
var floor$2 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
}; // @@replace logic


fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [// `String.prototype.replace` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
    return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
  }, // `RegExp.prototype[@@replace]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
  function (regexp, replaceValue) {
    var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    var functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    var global = rx.global;

    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }

    var results = [];

    while (true) {
      var result = regexpExecAbstract(rx, S);
      if (result === null) break;
      results.push(result);
      if (!global) break;
      var matchStr = String(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }

    var accumulatedResult = '';
    var nextSourcePosition = 0;

    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = String(result[0]);
      var position = max$1(min$2(toInteger(result.index), S.length), 0);
      var captures = []; // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

      for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));

      var namedCaptures = result.groups;

      if (functionalReplace) {
        var replacerArgs = [matched].concat(captures, position, S);
        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
        var replacement = String(replaceValue.apply(undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }

      if (position >= nextSourcePosition) {
        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }

    return accumulatedResult + S.slice(nextSourcePosition);
  }]; // https://tc39.github.io/ecma262/#sec-getsubstitution

  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }

    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;

      switch (ch.charAt(0)) {
        case '$':
          return '$';

        case '&':
          return matched;

        case '`':
          return str.slice(0, position);

        case "'":
          return str.slice(tailPos);

        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;

        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;

          if (n > m) {
            var f = floor$2(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }

          capture = captures[n - 1];
      }

      return capture === undefined ? '' : capture;
    });
  }
});

var arrayPush = [].push;
var min$3 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF; // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError

var SUPPORTS_Y = !fails(function () {
  return !RegExp(MAX_UINT32, 'y');
}); // @@split logic

fixRegexpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;

  if ('abbc'.split(/(b)*/)[1] == 'c' || 'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 || '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string]; // If `separator` is not a regex, use native split

      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }

      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0; // Make `global` and avoid `lastIndex` issues by working with a copy

      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;

      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;

        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }

        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }

      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));

      return output.length > lim ? output.slice(0, lim) : output;
    }; // Chakra, V8

  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [// `String.prototype.split` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = requireObjectCoercible(this);
    var splitter = separator == undefined ? undefined : separator[SPLIT];
    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
  }, // `RegExp.prototype[@@split]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (regexp, limit) {
    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    var C = speciesConstructor(rx, RegExp);
    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g'); // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.

    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];

    while (q < S.length) {
      splitter.lastIndex = SUPPORTS_Y ? q : 0;
      var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
      var e;

      if (z === null || (e = min$3(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        A.push(S.slice(p, q));
        if (A.length === lim) return A;

        for (var i = 1; i <= z.length - 1; i++) {
          A.push(z[i]);
          if (A.length === lim) return A;
        }

        q = p = e;
      }
    }

    A.push(S.slice(p));
    return A;
  }];
}, !SUPPORTS_Y);

var Mixin = {
  methods: {
    /**
     * 返回规范颜色值
     * @param {Number} index - 配色规范色号
     * @param {Number} [opacity = 1] - 透明度
     */
    mColor: function mColor(index) {
      var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var color = Object.assign({}, config.colors, this.colors);

      if (Number.isInteger(index)) {
        return color[index];
      } else {
        index = index.toString();

        switch (index) {
          case '2.1':
            opacity = 0.65;
            break;

          case '3.1':
            opacity = 0.5;
            break;

          case '8.1':
            opacity = 0.6;
            break;

          case '8.2':
            opacity = 0.3;
            break;

          case '15.1':
            opacity = 0.8;
            break;
        }

        var str = color[index.split('.')[0]];
        return str.includes('#') ? "rgba(".concat(Number.parseInt(str.substr(1, 2), 16), ", ").concat(Number.parseInt(str.substr(3, 2), 16), ", ").concat(Number.parseInt(str.substr(5, 2), 16), ", ").concat(opacity, ")") : str.replace('1)', opacity + ')');
      }
    }
  }
};

//
var script = {
  name: 'sui-actionsheet',
  mixins: [Mixin],
  data: function data() {
    return {
      show: false,
      title: '',
      options: [],
      colors: {},
      resolve: {},
      reject: {}
    };
  },
  watch: {
    'show': function show(nv) {
      if (!nv) {
        this.title = '';
      }
    }
  },
  methods: {
    /**
     * 选择选项
     * @param {String} option - 选项名称
     * @param {Number} index - 选项索引
     */
    switchOptions: function switchOptions(option, index) {
      this.show = false;
      this.resolve({
        option: option,
        index: index
      });
    },
    cancel: function cancel() {
      this.show = false;
      this.reject();
    }
  }
};

var css$3 = ".sui-actionsheet>ul{position:fixed;bottom:0;left:0;z-index:99;width:100%;margin:0;padding:0;font-size:17px;background:#fff}.sui-actionsheet>ul li{display:flex;justify-content:center;align-items:center;height:50px;margin:0;padding:0}.sui-actionsheet>ul .sui--option{background:linear-gradient(transparent,transparent 50%,#000 0) repeat-x bottom/1px 1px}.sui-actionsheet>ul .sui--title{font-size:16px;color:#000}.sui-actionsheet>ul .sui--cancel{border-top:10px solid;font-weight:500}@media (max-aspect-ratio:1/2){.sui-actionsheet>ul .sui--cancel{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}@media (min-aspect-ratio:2/1){.sui-actionsheet>ul .sui--cancel{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}.sui-actionsheet>.sui--mask{position:fixed;top:0;left:0;z-index:98;width:100%;height:100%;background:rgba(0,0,0,.6)}";
styleInject(css$3,{"insertAt":"top"});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-actionsheet"
  }, [_c("transition", {
    attrs: {
      name: "sui-animation--slide"
    }
  }, [_vm.show ? _c("ul", {
    style: {
      color: _vm.mColor(4),
      background: _vm.mColor(7)
    }
  }, [_vm.title ? _c("li", {
    staticClass: "sui--title",
    style: {
      color: _vm.mColor(1)
    }
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l(_vm.options, function (item, index) {
    return _c("li", {
      key: item,
      staticClass: "sui--option",
      style: {
        background: "linear-gradient(0deg, transparent, transparent 50%, " + _vm.mColor(8.1) + " 50%) repeat-x top / 1px 1px"
      },
      on: {
        click: function click($event) {
          return _vm.switchOptions(item, index);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), _vm._v(" "), _c("li", {
    staticClass: "sui--cancel",
    style: {
      "border-top-color": _vm.mColor(6)
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")])], 2) : _vm._e()]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "sui-animation--fade-fast"
    }
  }, [_vm.show ? _c("div", {
    staticClass: "sui--mask",
    on: {
      click: function click($event) {
        _vm.show = false;
      }
    }
  }) : _vm._e()])], 1);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var ActionSheetConstructor = Vue.extend(__vue_component__);
var instance = new ActionSheetConstructor().$mount();
/**
 * ActionSheet
 * @param {Object} params - 参数对象
 * @param {String} params.title - 标题
 * @param {Array} params.options - 操作选项
 * @param {Object} params.colors - 自定义主题色，优先级最高，可覆盖默认主题色与 SlugUI.config.colors 设置的主题色
 */

function ActionSheetInstance(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      options = _ref.options,
      colors = _ref.colors;
  return new Promise(function (resolve, reject) {
    instance.title = title.toString();
    instance.options = options;
    instance.colors = colors;
    instance.resolve = resolve;
    instance.reject = reject;
    instance.show = true;
    document.body.appendChild(instance.$el);
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.fill


var arrayFill = function fill(value
/* , start = 0, end = @length */
) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

  while (endPos > index) O[index++] = value;

  return O;
};

// https://tc39.github.io/ecma262/#sec-array.prototype.fill

_export({
  target: 'Array',
  proto: true
}, {
  fill: arrayFill
}); // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('fill');

var AddThin = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M221.483 133.75H133.75v87.733a8.753 8.753 0 01-17.5 0V133.75H28.517a8.753 8.753 0 010-17.5h87.733V28.517a8.753 8.753 0 0117.5 0v87.733h87.733a8.753 8.753 0 010 17.5z\"/></svg>";

var Add = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M214.341 140.438h-73.9v73.9a15.439 15.439 0 11-30.876.221v-74.121h-73.9a15.439 15.439 0 11-.221-30.876h74.124v-73.9a15.439 15.439 0 1130.876-.221v74.124h74.124a15.439 15.439 0 11-.221 30.876z\"/></svg>";

var ArrowBack = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M66.17 135a10.981 10.981 0 01-7.643-3.055 10.223 10.223 0 01-.325-14.454q.159-.167.325-.325l97.156-94.112a11.043 11.043 0 0115.254 0 10.223 10.223 0 01.325 14.453q-.159.167-.325.325L73.78 131.948A10.921 10.921 0 0166.17 135z\"/><path d=\"M163.316 230a10.979 10.979 0 01-7.643-3.055l-97.157-94.112a10.223 10.223 0 01-.324-14.454q.157-.166.324-.325a11.045 11.045 0 0115.254 0l97.156 94.113a10.222 10.222 0 01.325 14.453q-.159.166-.325.325a10.936 10.936 0 01-7.61 3.055z\"/></svg>";

var ArrowDown = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M135 184.056a10.979 10.979 0 01-3.055 7.643 10.223 10.223 0 01-14.454.325q-.167-.159-.325-.325L23.057 94.543a11.043 11.043 0 010-15.254 10.223 10.223 0 0114.453-.325q.167.159.325.325l94.113 97.157a10.921 10.921 0 013.052 7.61z\"/><path d=\"M230 86.911a10.981 10.981 0 01-3.055 7.643l-94.112 97.156a10.223 10.223 0 01-14.454.325q-.166-.159-.325-.325a11.044 11.044 0 010-15.253L212.167 79.3a10.222 10.222 0 0114.453-.324q.166.157.325.324A10.938 10.938 0 01230 86.911z\"/></svg>";

var ArrowDropdown = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M216.667 63H37.7C16.213 63 8.922 75.151 20.41 90.43S92 181.566 104.274 196.71s31.409 14.565 43.228 0 64.721-84.677 80.405-104.56S230.292 63 216.667 63z\"/></svg>";

var ArrowDropleft = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M188 216.669V37.7c0-21.488-12.2-28.779-27.544-17.292S68.946 92 53.744 104.273s-14.625 31.408 0 43.228 85.028 64.723 104.993 80.407S188 230.294 188 216.669z\"/></svg>";

var ArrowDropright = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M62 33.33V212.3c0 21.488 12.2 28.779 27.544 17.292s91.512-71.592 106.71-83.865 14.627-31.409 0-43.23-85.03-64.722-104.992-80.4S62 19.706 62 33.33z\"/></svg>";

var ArrowDropup = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M33.338 188H212.3c21.489 0 28.78-12.2 17.3-27.543S158 68.944 145.729 53.738s-31.406-14.625-43.233 0-64.712 85.027-80.4 104.992S19.712 188 33.338 188z\"/></svg>";

var ArrowForward = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M183.283 115a10.979 10.979 0 017.643 3.055 10.223 10.223 0 01.325 14.454q-.159.166-.325.325L93.77 226.943a11.043 11.043 0 01-15.254 0 10.223 10.223 0 01-.325-14.453c.106-.111.215-.219.325-.325l97.157-94.113a10.921 10.921 0 017.61-3.052z\"/><path d=\"M86.138 20a10.981 10.981 0 017.643 3.055l97.156 94.112a10.223 10.223 0 01.325 14.454q-.159.166-.325.325a11.044 11.044 0 01-15.253 0L78.527 37.833A10.222 10.222 0 0178.2 23.38q.157-.167.324-.325A10.938 10.938 0 0186.138 20z\"/></svg>";

var ArrowUp = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M115 66.943a10.981 10.981 0 013.055-7.643 10.223 10.223 0 0114.454-.325q.166.159.325.325l94.112 97.156a11.043 11.043 0 010 15.254 10.223 10.223 0 01-14.453.325q-.167-.159-.325-.325l-94.116-97.157a10.921 10.921 0 01-3.052-7.61z\"/><path d=\"M20 164.089a10.979 10.979 0 013.055-7.643l94.112-97.157a10.224 10.224 0 0114.454-.325q.166.159.325.325a11.045 11.045 0 010 15.254L37.833 171.7a10.223 10.223 0 01-14.453.325q-.167-.159-.325-.325A10.936 10.936 0 0120 164.089z\"/></svg>";

var BadOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M28.858 158.2c3.5 5.023 7.195 9.53 13.16 9.53h43.845l-11.074 39.319a22.545 22.545 0 0041.084 17.261l.093-.151a78.89 78.89 0 004.973-10.282c.764-1.792 1.491-3.492 2.191-5.2 4.9-11.756 8.774-21.048 18.257-29.449 11.9-10.483 20.884-10.646 20.884-10.588h51.578c5.7-.058 10.717-12.3 10.717-12.3V45.361a10.342 10.342 0 00-10.291-10.372H78.411A20.323 20.323 0 0059.323 48.52l-32.8 92.41a19.1 19.1 0 002.335 17.27zM180.016 45.9h33.64v110.92h-33.64zm-144.03 99.83l33.28-94.286c1.017-2.858 8.077-5.545 11.09-5.545h88.75V156.82c-2.55.236-8.7-.626-11.09 0-11.935 3.167-14.567 4.356-22.19 11.09-8.631 7.95-16.853 20.493-22.19 33.28-2.677 6.3-9.647 29.087-22.18 22.181-3.2-1.988-6.462-7.025-5.554-11.091l11.126-44.833c.345-6.57-5.273-10.872-11.126-10.627h-44.37c-7.425-.69-5.074-12.433-5.546-11.09z\"/></svg>";

var Bad = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M26.259 141.656l32.869-93.039a20.378 20.378 0 0119.127-13.623h91.125v132.735h-6.761c0 .855-8.946 1.018-20.783 11.5-9.437 8.4-13.3 17.692-18.174 29.447-.7 1.709-1.427 3.409-2.182 5.2a79.77 79.77 0 01-4.946 10.283 22.532 22.532 0 01-30.954 7.564l-.266-.164c-7.982-5.009-11.9-14.855-9.773-24.51l11.028-38.412H41.786c-5.977 0-9.686-4.538-13.194-9.595a19.283 19.283 0 01-2.333-17.386zM180.29 34.994h34.21a10.391 10.391 0 0110.341 10.423V156.4c0 5.748-5.234 12.242-10.943 12.242H180.29z\"/></svg>";

var Bookmarks = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M180.8 32.62H69.2A37.186 37.186 0 0032 69.573v110.854a37.186 37.186 0 0037.2 36.953h111.6a37.186 37.186 0 0037.2-36.953V69.573a37.186 37.186 0 00-37.2-36.953zm-83.08 1.24h55.8V79.9l-27.9-18.875-27.9 17.952zm63.659 98.6l-13.906 13.352a2.835 2.835 0 00-.928 3.222l3.246 18.415a3.6 3.6 0 01-5.563 3.684l-17.15-8.748a5.119 5.119 0 00-3.71 0l-17.15 9.208c-2.781 1.381-6.026-.921-5.563-3.683l3.245-18.41c0-1.382 0-2.3-.927-3.223l-13.906-13.355a3.78 3.78 0 011.854-6.441l19-2.762a3.128 3.128 0 002.781-1.842l8.344-17.033a3.952 3.952 0 016.953 0l8.344 17.033a3.813 3.813 0 002.781 1.842l19 2.762c4.172 0 5.1 3.679 3.245 5.98z\"/></svg>";

var Calendar = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M112.886 186.739a6.146 6.146 0 01-4.358-1.805l-30.817-30.817a6.163 6.163 0 018.717-8.716l26.458 26.459L164 120.748a6.163 6.163 0 018.717 8.716l-55.47 55.47a6.146 6.146 0 01-4.361 1.805z\"/><path d=\"M198.933 218H50.85a18.509 18.509 0 01-18.51-18.465v-136a19.17 19.17 0 0119.148-19.149h12.728a6.383 6.383 0 11.039 12.766H51.292a6.184 6.184 0 00-6.186 6.17v135.742a6.184 6.184 0 006.186 6.17h148.475a6.186 6.186 0 006.187-6.17V62.9a5.751 5.751 0 00-5.745-5.744h-11.19A5.945 5.945 0 01183 51.922a5.744 5.744 0 015.72-6.259h10.213a18.508 18.508 0 0118.51 18.464v135.408A18.509 18.509 0 01198.933 218z\"/><path d=\"M150.744 57.152H99.681a6.383 6.383 0 010-12.766h51.063a6.383 6.383 0 010 12.766zm16.1 12.812a6.343 6.343 0 01-4.295-6.089V38.381a6.383 6.383 0 0112.766 0v25.532a6.4 6.4 0 01-8.47 6.051zm-86.807 0a6.343 6.343 0 01-4.3-6.089V38.381a6.383 6.383 0 0112.766 0v25.532a6.4 6.4 0 01-8.465 6.051zM211.5 100.555H38.927a6.386 6.386 0 010-12.765H211.5a6.386 6.386 0 010 12.765z\"/></svg>";

var Check = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M108.506 189.012a7.907 7.907 0 01-5.6-2.4l-72.06-72.06a7.926 7.926 0 0111.209-11.209L108.5 169.8 214.99 63.31a7.926 7.926 0 0111.21 11.209L114.11 186.61a7.9 7.9 0 01-5.604 2.402z\"/></svg>";

var CloseCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 20A105 105 0 1120 125 105 105 0 01125 20zm12.819 105.39L177.2 86.44a9.108 9.108 0 00-12.81-12.95l-39.428 39-38.83-38.955A9.108 9.108 0 0073.235 86.4l38.78 38.9-39.1 38.675A9.108 9.108 0 0085.634 177c.03-.028.059-.057.087-.086l39.148-38.714 39.471 39.6a9.107 9.107 0 1012.9-12.862l-39.418-39.544z\"/></svg>";

var CloseThin = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M209.4 53.15l-71.835 71.835L209.4 196.85a8.873 8.873 0 11-12.55 12.55l-71.837-71.84-71.865 71.834A8.873 8.873 0 1140.6 196.845l71.866-71.865L40.6 53.15A8.873 8.873 0 0153.153 40.6l71.86 71.864L196.878 40.6A8.863 8.863 0 11209.4 53.149z\"/></svg>";

var Close = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M143 124.988l65.269 65.269a12.727 12.727 0 01-18 18L125 142.988l-65.274 65.267a12.727 12.727 0 01-18-18L107 124.988 41.728 59.719a12.734 12.734 0 0118.008-18.008l65.269 65.269 65.231-65.232a12.73 12.73 0 1118.008 18z\"/></svg>";

var Crown = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M215.91 101.568h-.01l-22.541 84.166H56.61l-22.529-84.166a14.039 14.039 0 1112.093-6.978l33.162 21.292 37.385-54.159a16.06 16.06 0 1116.565.024l37.366 54.1 33.1-21.239a13.85 13.85 0 01-1.927-7.046 14.089 14.089 0 1114.174 14zm-93.256 13.643l-18.709 23.411 18.709 28.094 18.711-28.094zM188.99 202.1c-2.458 17.975-22.78 15.9-22.78 15.9H84.324s-20.261 2.071-22.712-15.855l-1.95-7.291h131.27z\"/></svg>";

var Edit = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M221.568 51.359a8.537 8.537 0 00-12.07 0l-84.489 84.486a8.535 8.535 0 0012.07 12.07l84.489-84.486a8.592 8.592 0 000-12.07zm-30.9 90.481a8.253 8.253 0 00-8.033 8.456v41.984a8.456 8.456 0 01-8.456 8.456H63.749a8.474 8.474 0 01-8.492-8.455V57.87a8.607 8.607 0 018.607-8.606h85.9a8.607 8.607 0 10.168-17.213H54.945a16.9 16.9 0 00-16.9 16.9v152.1a16.9 16.9 0 0016.9 16.9h126.839a16.913 16.913 0 0016.916-16.915V150.3a8.252 8.252 0 00-8.032-8.456z\"/></svg>";

var EyeOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 50.5c9.659 0 19.824 2.74 30.265 8.153A131.7 131.7 0 01183.828 79.4c15.829 14.726 28.228 31.466 35.3 41.985a6.449 6.449 0 010 7.23c-7.073 10.519-19.472 27.259-35.327 42.006-9.607 8.937-19.214 15.909-28.554 20.751-10.441 5.413-20.615 8.151-30.265 8.151s-19.833-2.739-30.274-8.151c-9.34-4.842-18.947-11.811-28.563-20.751-15.828-14.747-28.22-31.487-35.292-42.006a6.42 6.42 0 010-7.23c7.072-10.519 19.463-27.259 35.318-42.007a131.866 131.866 0 0128.564-20.75C105.15 53.238 115.35 50.5 125 50.5m0-13.147c-51.24 0-94.438 59.842-107.912 80.637a12.82 12.82 0 000 14.025c13.474 20.795 56.7 80.636 107.912 80.636s94.438-59.843 107.912-80.636a12.82 12.82 0 000-14.025C219.438 97.193 176.215 37.351 125 37.351zm-.009 0v56.97a31.652 31.652 0 0122.231 8.984 30.168 30.168 0 01.727 42.658q-.357.37-.727.728a32 32 0 01-44.461 0 30.168 30.168 0 01-.728-42.658q.359-.37.728-.728a31.65 31.65 0 0122.231-8.984M125 81.175c-24.808 0-44.907 19.612-44.907 43.825s20.1 43.825 44.907 43.825 44.908-19.612 44.908-43.825S149.791 81.175 125 81.175z\"/></svg>";

var FemaleCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><circle cx=\"125\" cy=\"125\" r=\"105\"/><path d=\"M176.858 71.266A44.659 44.659 0 00113.7 70.9q-.5.492-.98 1a47.146 47.146 0 00-4.187 59.9l-10.568 11-22-22.068a7.155 7.155 0 00-10.116-.17 12.22 12.22 0 00-.161.161 7.544 7.544 0 00-.009 10.5l.105.1 22.013 22.071-14.978 15.6a7.55 7.55 0 00.241 10.5 7.154 7.154 0 0010.117-.084l.014-.014 14.973-15.6 22 22.068A7.155 7.155 0 00125.25 188a7.347 7.347 0 007.265-7.426 7.512 7.512 0 00-2.178-5.3l-22-22.066 10.559-11a44.617 44.617 0 0058.575-5.373 47.1 47.1 0 00-.611-65.563zm-9.76 55.157a30.353 30.353 0 01-42.911 1.086q-.345-.328-.679-.666a32.009 32.009 0 01-.419-44.558A30.35 30.35 0 01166 81.2q.345.329.681.667a32.01 32.01 0 01.419 44.558z\" fill=\"#fff\"/></svg>";

var Female = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M201.7 45.409a68.705 68.705 0 00-97.162-.57q-.766.758-1.508 1.538a72.532 72.532 0 00-6.442 92.154l-16.257 16.936-33.853-33.949a11.005 11.005 0 00-15.562-.262 9.626 9.626 0 00-.248.247 11.606 11.606 0 00-.014 16.157l.161.161 33.867 33.956-23.044 24a11.615 11.615 0 00.371 16.155 11.006 11.006 0 0015.564-.129l.022-.022 23.036-24 33.851 33.95a11 11 0 007.826 3.269 11.3 11.3 0 0011.176-11.425 11.556 11.556 0 00-3.35-8.155l-33.85-33.948 16.246-16.931a68.64 68.64 0 0090.115-8.266 72.456 72.456 0 00-.945-100.866zm-15.015 84.857a46.7 46.7 0 01-66.016 1.671q-.531-.506-1.045-1.025a49.246 49.246 0 01-.645-68.551A46.694 46.694 0 01185 60.688q.531.505 1.047 1.028a49.243 49.243 0 01.645 68.55z\"/></svg>";

var Fire = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M139.928 4s7.36 28.573 7.36 51.757c0 22.214-13.429 40.275-33.978 40.275S77.235 78.025 77.235 55.757l.248-3.882c-20.771 26.87-32.129 60.812-32.094 95.861C45.389 195.4 81.013 234 125 234s79.607-38.6 79.607-86.264C204.611 89.562 178.789 37.7 139.928 4zm-21.921 185.769c-15.746 0-28.529-11.241-28.529-25.123 0-13 9.245-22.122 24.9-24.964s31.846-9.642 40.825-20.6a101.778 101.778 0 015.264 32.288c.002 21.149-19.017 38.399-42.46 38.399z\"/></svg>";

var Flag = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M38.674 30h172.652v150.476L125 230l-86.326-49.524z\"/></svg>";

var FunnelOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M140.16 230.581a23.51 23.51 0 01-12.127-3.409l-30.32-18.94A22.212 22.212 0 0187.1 188.915v-64.774L40.865 67.7A22.637 22.637 0 0158.3 30.585h133.024a22.638 22.638 0 0117.812 37.12L162.9 124.144v83.71a22.192 22.192 0 01-11.748 19.7 22.847 22.847 0 01-10.992 3.027zM58.336 45.355a7.545 7.545 0 00-6.849 4.167 7.2 7.2 0 001.141 7.954l48.321 58.71a7.951 7.951 0 011.9 4.922v67.423a8.429 8.429 0 003.424 6.439l30.439 18.938c3.425 2.273 6.468.758 7.614.379a7.59 7.59 0 003.8-6.439v-86.737a7.951 7.951 0 011.9-4.922l48.317-58.717a8.078 8.078 0 001.141-7.954c-.381-1.136-2.283-4.167-6.849-4.167z\"/></svg>";

var Gift = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M174.788 67.691a30.036 30.036 0 004.087-15.063c0-13.644-9.39-27.452-27.349-27.452a28.345 28.345 0 00-20.977 8.6 37.638 37.638 0 00-7.113 10.562 37.525 37.525 0 00-6.972-10.548 28.17 28.17 0 00-20.908-8.616c-10.641 0-17.056 4.746-20.568 8.728a28.172 28.172 0 00-6.781 18.722 30.063 30.063 0 004.086 15.065H40.384A15.384 15.384 0 0025 83.075v38.583a15.385 15.385 0 0015.384 15.384v65.223a22.563 22.563 0 0022.561 22.559h124.108a22.554 22.554 0 0022.562-22.554v-65.214A15.385 15.385 0 00225 121.672V80.1a12.409 12.409 0 00-12.409-12.409zm-34.945-24.747a15.573 15.573 0 0111.671-4.709c10.546 0 14.291 7.752 14.291 14.393a16.325 16.325 0 01-3.685 10.563 13.269 13.269 0 01-10.581 4.5l-20.839-.168c.792-7.6 3.165-18.51 9.134-24.579zM81.27 52.628a15.149 15.149 0 013.519-10.095c2.514-2.854 6.136-4.308 10.766-4.308a15.25 15.25 0 0111.5 4.641c5.915 6.075 8.172 17.132 8.876 24.824H95.555c-11.278.001-14.285-9.468-14.285-15.062zM46.919 80.754h53.591v43.239H46.919a8.858 8.858 0 01-8.861-8.86V89.614a8.86 8.86 0 018.861-8.86zm6.533 56.3h47.058v74.707H63.634a10.182 10.182 0 01-10.182-10.178v-64.527zm60.12 74.707V80.754h22.858v131.009zm72.791 0H149.49v-74.705h47.052v64.529a10.182 10.182 0 01-10.179 10.178zm16.714-87.77H149.49V80.754h53.587a8.862 8.862 0 018.861 8.86v25.519a8.86 8.86 0 01-8.861 8.86z\"/></svg>";

var GoodOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M208.269 81.442H163.26l11.047-38.323a22.867 22.867 0 00-9.8-24.451 22.633 22.633 0 00-31.183 7.221l-.1.159a79.235 79.235 0 00-4.961 10.264 402.833 402.833 0 00-2.186 5.185c-4.888 11.729-8.752 21-18.212 29.376C96 81.33 89.409 82.349 87.038 82.349H35.586c-5.918 0-10.661 5.057-10.661 11.354V204.35a10.385 10.385 0 0010.336 10.416h136.456a20.412 20.412 0 0019.171-13.591l32.944-92.813c3.836-9.362-1.164-26.92-15.563-26.92zM69.367 203.883H35.809V93.233h33.558zM213.039 104.3c-2.371 4.7-32.022 91.4-33.2 94.052s-8.057 5.532-11.063 5.532H80.25V93.234h11.063c5.355 0 14.53-4.346 22.134-11.066 8.61-7.927 16.812-20.44 22.135-33.193 2.671-6.286 9.623-29.021 22.125-22.129 3.2 1.986 6.446 7.014 5.541 11.062l-11.1 44.722c-.344 6.56 5.26 10.844 11.1 10.6h44.26c5.16.003 7.903 6.37 5.531 11.07z\"/></svg>";

var Good = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M223.642 108.341l-32.836 92.945A20.36 20.36 0 01171.7 214.9H80.665V81.386h6.358c1.816 0 9.389-.3 21.214-10.773 9.427-8.389 13.287-17.671 18.156-29.416.7-1.705 1.426-3.406 2.179-5.193a80.137 80.137 0 014.941-10.278 22.5 22.5 0 0130.915-7.56l.274.169c7.974 5.007 11.889 14.84 9.763 24.486l-11.016 38.565h44.681c5.972 0 9.677 4.54 13.182 9.584a19.27 19.27 0 012.33 17.371zM69.766 214.9H35.593a10.379 10.379 0 01-10.33-10.41V93.619c0-5.744 5.229-12.233 10.932-12.233h33.571z\"/></svg>";

var GroupCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><circle cx=\"125\" cy=\"125\" r=\"105\"/><path d=\"M144.5 115.457a33.177 33.177 0 10-40.752 0A54.847 54.847 0 0069 166.314v10.957a5.479 5.479 0 005.479 5.479h99.259a5.493 5.493 0 005.512-5.474v-10.962a54.832 54.832 0 00-34.75-50.857zM124.372 66.94a21.914 21.914 0 11-21.914 21.914 21.913 21.913 0 0121.914-21.914zM168.75 170.5h-87.5v-5.479a43.75 43.75 0 1187.5-.034v5.513z\" fill=\"#fff\"/><path d=\"M86.357 116.585q.172-.792.349-1.584a5.043 5.043 0 00-.04-1.215 4.344 4.344 0 00-.02-.635c-.03-.123-.117-.21-.154-.336a5.329 5.329 0 00-.307-.67 5.1 5.1 0 00-.775-1.226c-.047-.052-.1-.088-.154-.138a5.042 5.042 0 00-1.651-1.149c-10.848-4.825-13.554-20.406-1.147-28.6a6.3 6.3 0 013-.964c4.723-.377 7.105-6.552 2.049-10.2a2.682 2.682 0 00-2.012-.494 26.225 26.225 0 00-14.914 43.483A41.827 41.827 0 0048 150.126v8.122a5.251 5.251 0 0010.5 0v-8.122a31.337 31.337 0 0123.769-30.505 5.2 5.2 0 004.088-3.036zM177.682 112.864a26.222 26.222 0 00-12.357-42.9 5.416 5.416 0 00-6.4 2.844 5.254 5.254 0 003.425 7.23 15.752 15.752 0 012.312 29.6 5.151 5.151 0 00-1.677 1.164c-.042.047-.092.077-.134.123a5.136 5.136 0 00-.785 1.241 5.575 5.575 0 00-.3.656c-.035.117-.122.209-.154.335a4.353 4.353 0 00-.02.636 5.084 5.084 0 00-.04 1.214 4.554 4.554 0 00.132.6 4.746 4.746 0 00.215.985 5.2 5.2 0 004.085 3.035 31.338 31.338 0 0123.769 30.506v8.122a5.251 5.251 0 0010.5 0v-8.122a41.83 41.83 0 00-22.571-37.269z\" fill=\"#fff\"/></svg>";

var HappyOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 230a105 105 0 11105-105 105 105 0 01-105 105zm63.64-168.875a90 90 0 00-128.177.913c-33.8 34.753-33.8 90.7 0 125.452A90 90 0 10188.637 61.125zm-17.309 57.75h-6.709a6.636 6.636 0 01-6.708-6.563V99.188a6.636 6.636 0 016.708-6.563h6.709a6.636 6.636 0 016.708 6.563v13.124a6.636 6.636 0 01-6.708 6.563zm-.292 25.813a45.94 45.94 0 01-48.382 45.874c-24.516-1.271-43.493-22.053-43.493-46.6v-5.835h91.875zm-85.458-25.813h-6.709a6.636 6.636 0 01-6.708-6.563V99.188a6.636 6.636 0 016.708-6.563h6.709a6.636 6.636 0 016.708 6.563v13.124a6.636 6.636 0 01-6.708 6.563z\"/></svg>";

var Headset = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M228.579 126.627a36.631 36.631 0 00-25.095-34.645 77.759 77.759 0 00-155.045-.564 36.624 36.624 0 00-27.018 35.209c0 22.432 18.248 36.211 36.515 36.211h15.033V89.349H57.74a68.411 68.411 0 0167.814-60.924c34.788 0 63.972 26.577 67.818 61.006-.531-.024-1.053-.082-1.585-.082h-15.473v73.489h15.745a1.626 1.626 0 001.168.242c-5.3 32.539-33.889 57.351-67.318 57.351a4.785 4.785 0 000 9.569c39.194 0 72.533-29.922 77.178-68.581a36.656 36.656 0 0025.492-34.792zm-164.8 27.025h-5.4c-13.131 0-25.695-10.6-27.274-23.633A27.015 27.015 0 0157.89 99.683h5.893zm128.265 0h-5.4V99.683h5.893a27.016 27.016 0 0126.781 30.337c-1.575 13.036-14.139 23.632-27.27 23.632z\"/></svg>";

var History = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125.006 230A105 105 0 11230 124.994V125a105.007 105.007 0 01-104.994 105zm0-192.5a87.5 87.5 0 1087.494 87.506v-.015A87.5 87.5 0 00125.006 37.5zm3.134 99.216c-4.795 2.757-27.28 15.75-27.28 15.75s-9.721 4.165-14.344-3.841 3.844-14.341 3.844-14.341l25.89-14.954V73.751s1.045-10 8.75-10 8.75 10 8.75 10v50c0 5.049-.816 10.209-5.61 12.965z\"/></svg>";

var Home = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M220.168 105.45L139.6 30.324a21.558 21.558 0 00-32.116-.3l-77.6 75.354a13.574 13.574 0 00-2.843 14.83c2.138 5.095 7.119 8.3 12.646 8.967h7.243v76.268A21.429 21.429 0 0068.316 227h33.334a8.189 8.189 0 008.165-8.165v-51.126a3.594 3.594 0 013.594-3.594h23.679a3 3 0 013 3v53.746a6.135 6.135 0 006.14 6.139h40.924a17.041 17.041 0 0016.991-16.991v-81.995h6.157a12.384 12.384 0 0012.623-7.757 13.477 13.477 0 00-2.755-14.807z\"/></svg>";

var Letter = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M89.786 74.514h70.875c2.878 0 7.09-4.168 7.09-7.09s-4.212-7.081-7.09-7.081H89.786a7.342 7.342 0 00-7.081 7.081 7.2 7.2 0 007.081 7.09zm-.1 28.343H139.3c2.869 0 6.405-3.773 6.405-6.695 0-4.466-3.536-7.476-6.405-7.476H89.683c-2.869 0-7.081 4.168-7.081 7.081s4.212 7.09 7.081 7.09zm117.935-17.493l-10.878-10.442V39.157c0-2.985-4.483-7.157-7.378-7.157H60.644c-2.9 0-7.387 4.163-7.387 7.157v35.765L42.378 85.373 32 90.714v121.954a5.186 5.186 0 00.412 2.064c.018.053.053.1.07.159a5.683 5.683 0 00.518.886 5.082 5.082 0 004 2.205c.061 0 .122.018.193.018h175.622a5.259 5.259 0 005.185-5.331V91.21l-10.379-5.846zm-12.65 4.251l12.356 7.308-12.356 7.307V89.615zM68.314 46.171h114.257c2.609 0 0-2.639 0 0v64.392l-57.124 28.608-57.133-28.608V46.171c.009-2.648-2.59 0 0 0zm-12.4 58.059l-12.355-7.307 12.355-7.316v14.623zm147.914 98.713H46.171v-93s67.845 41.1 71.66 42.922c5.492 2.161 2.485 4.853 14.338 0l71.66-42.922v93z\"/></svg>";

var Loading = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M212.33 137.67h-25.243a12.67 12.67 0 11-.1-25.34h25.243a12.67 12.67 0 11.1 25.34zm-34.543-47.865a12.443 12.443 0 01-17.6-17.592l17.6-17.593a12.44 12.44 0 1117.593 17.593zM124.7 225a12.674 12.674 0 01-12.669-12.67v-25.243a12.67 12.67 0 1125.339-.1v25.343A12.674 12.674 0 01124.7 225zm0-149.321a12.674 12.674 0 01-12.669-12.67V37.766a12.67 12.67 0 1125.339-.1v25.343a12.675 12.675 0 01-12.67 12.67zM72.213 195.38a12.44 12.44 0 11-17.593-17.593l17.593-17.6a12.443 12.443 0 0117.592 17.6zm0-105.575L54.62 72.213A12.44 12.44 0 0172.213 54.62l17.592 17.593a12.439 12.439 0 01-17.592 17.592zM75.679 125a12.676 12.676 0 01-12.67 12.67H37.766a12.67 12.67 0 11-.1-25.34h25.343A12.676 12.676 0 0175.679 125zm102.108 35.186l17.593 17.592a12.444 12.444 0 01-17.468 17.727l-.125-.125-17.6-17.6a12.443 12.443 0 1117.476-17.717l.124.123z\"/></svg>";

var MaleCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><circle cx=\"125\" cy=\"125\" r=\"105\"/><path d=\"M178.2 64c-3.7 0-54.3.2-54.3.2a7 7 0 00.024 14h.322l37.67-.14-24.77 25.47a48.916 48.916 0 00-30.675-10.882h-.564c-27.374.367-49.349 23.4-48.989 51.337C57.274 171.567 79.536 194 106.546 194h.664a48.841 48.841 0 0034.911-15.311 51.291 51.291 0 004.46-65.21L171.364 88v38.417a6.862 6.862 0 1013.722 0v-55.44A6.925 6.925 0 00178.2 64zm-47.52 103.226a33.179 33.179 0 01-23.717 10.4h-.455c-18.347 0-33.47-15.242-33.712-33.976-.244-18.982 14.686-34.628 33.282-34.878h.454c18.349 0 33.473 15.24 33.712 33.977a34.577 34.577 0 01-9.564 24.472z\" fill=\"#fff\"/></svg>";

var Male = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M208 30c-5.692 0-83.538.307-83.538.307a10.775 10.775 0 00.037 21.545h.5l57.954-.215-38.1 39.178a75.259 75.259 0 00-47.206-16.741l-.868.006c-42.113.565-75.92 36-75.367 78.981C21.959 195.488 56.21 230 97.763 230l1.021-.007a75.145 75.145 0 0053.71-23.556 78.9 78.9 0 006.861-100.323l38.128-39.2v59.1a10.558 10.558 0 1021.111 0V40.735A10.655 10.655 0 00208 30zm-73.109 158.809A51.047 51.047 0 0198.4 204.815h-.7c-28.227 0-51.494-23.449-51.866-52.271-.375-29.2 22.594-53.274 51.2-53.659h.7c28.229 0 51.5 23.447 51.864 52.272a53.2 53.2 0 01-14.713 37.65z\"/></svg>";

var Menu = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M45.882 151.092a26.092 26.092 0 1126.3-26.084 26.093 26.093 0 01-26.3 26.084zm78.908 0a26.092 26.092 0 1126.3-26.084 26.092 26.092 0 01-26.3 26.084zm78.907 0A26.092 26.092 0 11230 125.008a26.094 26.094 0 01-26.3 26.084z\"/></svg>";

var MessageOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M36.792 222.833a9.9 9.9 0 01-3.054-.68 6.427 6.427 0 01-3.732-6.122V59.564a20.443 20.443 0 0120.357-20.409h149.28A20.443 20.443 0 01220 59.564v115.648a20.443 20.443 0 01-20.357 20.409H75.469a9.607 9.607 0 00-4.411 1.36l-30.2 24.152a4.934 4.934 0 01-4.066 1.7zm13.995-171.11a6.845 6.845 0 00-6.811 6.838v142.92l19.41-15.381a21.717 21.717 0 0112.6-4.445h124.63a6.845 6.845 0 006.811-6.839V58.567a6.844 6.844 0 00-6.811-6.838zm33.7 75.711a7.006 7.006 0 01-6.985-6.985v-6.986a6.986 6.986 0 0113.97 0v6.986a7.007 7.007 0 01-6.985 6.985zm40.514 0a7.007 7.007 0 01-6.986-6.985v-6.986a6.986 6.986 0 0113.97 0v6.986a7.006 7.006 0 01-6.985 6.985zm40.513 0a7.007 7.007 0 01-6.986-6.985v-6.986a6.986 6.986 0 0113.971 0v6.986a7.007 7.007 0 01-6.985 6.985z\"/></svg>";

var Message = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M199.643 39.155H50.363a20.443 20.443 0 00-20.357 20.409v156.467a6.427 6.427 0 003.732 6.122 9.9 9.9 0 003.054.68 4.934 4.934 0 004.071-1.7l30.2-24.152a9.607 9.607 0 014.411-1.36h124.169A20.443 20.443 0 00220 175.212V59.564a20.443 20.443 0 00-20.357-20.409zM91.475 120.449a7.005 7.005 0 01-6.985 6.984 7.006 7.006 0 01-6.985-6.985v-6.986a6.986 6.986 0 0113.97 0zm40.513 0a7 7 0 01-6.988 6.984 7.007 7.007 0 01-6.986-6.985v-6.986a6.986 6.986 0 0113.97 0zm40.514 0a7.005 7.005 0 01-6.985 6.984 7.007 7.007 0 01-6.986-6.985v-6.986a6.986 6.986 0 0113.971 0z\"/></svg>";

var Paper = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M71.912 125.749a3.873 3.873 0 003.849 2.971h80.162a3.723 3.723 0 100-7.44H75.715a3.769 3.769 0 00-3.803 4.469zM173.745 148.25H75.751a3.861 3.861 0 00-3.842 2.986 3.768 3.768 0 003.806 4.454h97.991a3.868 3.868 0 003.844-2.966 3.77 3.77 0 00-3.805-4.474zM173.745 174.29H75.752a3.862 3.862 0 00-3.844 2.991 3.767 3.767 0 003.807 4.449h98a3.861 3.861 0 003.839-2.976 3.77 3.77 0 00-3.809-4.464z\"/><path d=\"M204.472 89.125a3.741 3.741 0 00-.213-1.054c-.042-.116-.069-.228-.119-.337a3.868 3.868 0 00-.751-1.131L150 33.135a3.922 3.922 0 00-1.134-.759c-.1-.047-.213-.074-.321-.112a3.805 3.805 0 00-1.076-.217 2.158 2.158 0 00-.22-.047H76.1a30.616 30.616 0 00-30.615 30.616v124.772A30.613 30.613 0 0076.1 218h97.846a30.631 30.631 0 0030.572-30.612V89.35a2.079 2.079 0 00-.046-.225zm-53.9-44.334l40.222 40.219h-30.729a9.49 9.49 0 01-9.49-9.49zM173.29 209.63H75.78a22.854 22.854 0 01-22.855-22.855V62.3A22.854 22.854 0 0175.78 39.44h67.355v36.692a17.248 17.248 0 0017.248 17.248h35.762v93.4a22.855 22.855 0 01-22.855 22.85z\"/></svg>";

var PictureOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M92.541 117.71a24.915 24.915 0 11.309 0zm0-35.922a10.744 10.744 0 1010.743 10.744 10.551 10.551 0 00-10.356-10.745h-.387zM196.449 217.95h-143A21.513 21.513 0 0132 196.5v-143a21.513 21.513 0 0121.45-21.45h143A21.513 21.513 0 01217.9 53.5v143a21.513 21.513 0 01-21.451 21.45zM52.835 45.72a7.186 7.186 0 00-7.166 7.165V196.2a7.187 7.187 0 007.166 7.165h143.318a7.187 7.187 0 007.166-7.165V52.885a7.187 7.187 0 00-7.166-7.165zm58.329 124.886a22.6 22.6 0 01-15.758-6.806l-8.6-8.953a7.35 7.35 0 00-10.388 0l-11.1 11.818a7.257 7.257 0 01-10.024.359c-2.865-2.507-2.865-7.163-.358-10.024l11.1-11.819a21.174 21.174 0 0115.4-6.8 22.6 22.6 0 0115.759 6.8l8.595 8.954a7.351 7.351 0 0010.389 0L152 116.531a21.369 21.369 0 0115.759-6.8 21.97 21.97 0 0115.759 6.8l32.582 34.377a7.1 7.1 0 01-10.389 9.67L173.122 126.2a7.348 7.348 0 00-10.388 0l-35.813 37.963a23.853 23.853 0 01-15.757 6.447z\"/></svg>";

var PinCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><circle cx=\"125\" cy=\"125\" r=\"105\"/><path d=\"M123.165 60.374a52.928 52.928 0 00-53.081 52.776v.306c0 28.953 40.053 82.035 53.081 82.035s53.082-53.082 53.082-82.035a52.929 52.929 0 00-52.775-53.082zm.2 123.129c-8.686 0-43.431-47.774-43.431-69.971a43.431 43.431 0 1186.861 0c.005 22.197-34.74 69.968-43.428 69.968z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".4\"/><path d=\"M123.367 94.229a19.3 19.3 0 1019.3 19.3h0a19.36 19.36 0 00-19.3-19.3zm0 28.954a9.651 9.651 0 119.65-9.652h0a9.68 9.68 0 01-9.65 9.652z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".4\"/></svg>";

var PinOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 15a86.179 86.179 0 00-86.428 85.929v.5C38.572 148.572 103.785 235 125 235s86.428-86.428 86.428-133.571A86.179 86.179 0 00125.5 15zm-.713 199.989c-14.144 0-70.715-77.786-70.715-113.928A70.715 70.715 0 11195 100.338v.723c0 36.142-56.57 113.928-70.713 113.928z\"/><path d=\"M124.829 69.632a31.429 31.429 0 1031.429 31.429 31.429 31.429 0 00-31.429-31.429zm0 47.142a15.714 15.714 0 1115.713-15.713 15.759 15.759 0 01-15.713 15.713z\"/></svg>";

var PlayCircleOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 230c-57.75 0-105-47.25-105-105S67.25 20 125 20s105 47.25 105 105-47.249 105-105 105zm-.01-195c-49.5 0-90 40.5-90 90s40.5 90 90 90 90-40.5 90-90-40.5-90-90-90zm-18.644 127.5a7.232 7.232 0 01-3.746-1.125A7.734 7.734 0 0198.853 155V95a7.258 7.258 0 013.747-6.374 6.813 6.813 0 017.5 0l52.125 30a7.734 7.734 0 013.747 6.374 7.259 7.259 0 01-3.747 6.375l-52.125 30a7.223 7.223 0 01-3.754 1.125zm8.189-54.375v34.125l29.621-16.875z\"/></svg>";

var Play = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M67.463 27.063l150.691 84.759a15.024 15.024 0 010 26.352L67.463 222.941c-10.414 5.853-23.425-1.469-23.425-13.177V40.235c0-11.709 13.011-19.035 23.425-13.172z\"/></svg>";

var SadOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 20a105 105 0 10105 105A105 105 0 00125 20zm63.639 168.639A90.012 90.012 0 11214.994 125a90.011 90.011 0 01-26.355 63.639zM81.918 91.905a10.066 10.066 0 0110.063 10.062v6.633a10.063 10.063 0 11-20.125.08v-6.708a10.066 10.066 0 0110.062-10.067zm85.75 0a10.066 10.066 0 0110.063 10.062v6.633a10.063 10.063 0 11-20.125.08v-6.708a10.066 10.066 0 0110.062-10.067zM77.82 165.81a7.41 7.41 0 0010-3.143l.013-.024c11.813-15.435 24.01-19.443 38.316-19.443 13.4 0 29.094 4.69 38.168 19.145a7.417 7.417 0 0013.537-6.067l-.071-.154c-12-20.151-31.946-27.878-51.634-27.878-22.461 0-39.891 8.374-51.494 27.589a7.421 7.421 0 003.168 9.975z\"/></svg>";

var Search = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M222.17 221.718c-7.232 7.385-15.918 0-15.918 0l-32.208-33.011a87.75 87.75 0 01-59.09 23.043c-49.728 0-90.036-41.8-90.036-93.379S65.226 25 114.951 25s90.02 41.79 90.02 93.371a95.3 95.3 0 01-16 53.079l33.2 34.025s6.551 9.551-.001 16.243zM114.951 45.06c-38.675 0-70.028 32.811-70.028 73.308s31.35 73.321 70.028 73.321c38.662 0 70.012-32.824 70.012-73.321s-31.35-73.308-70.012-73.308z\"/></svg>";

var Setting = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M20 116.245a13.145 13.145 0 012.791-6.656 12.859 12.859 0 015.884-4.173l20.23-7.2a81.442 81.442 0 013.376-8.11L43.069 70.7a13.169 13.169 0 011.5-13.735l12.4-12.4a13.021 13.021 0 016.657-2.7 13.342 13.342 0 017.08 1.2l19.41 9.212a87.735 87.735 0 018.137-3.377l7.2-20.227a13.381 13.381 0 014.173-5.886A13.078 13.078 0 01116.28 20h17.44a13.161 13.161 0 016.658 2.789 12.894 12.894 0 014.174 5.886l7.2 20.227a83.888 83.888 0 018.135 3.376l19.41-9.212a13.175 13.175 0 0113.738 1.5l12.4 12.4a13.017 13.017 0 012.7 6.656 13.358 13.358 0 01-1.2 7.079l-9.216 19.409a87.022 87.022 0 013.376 8.111l20.23 7.195a13.354 13.354 0 015.886 4.173 12.98 12.98 0 012.789 6.656v17.463a13.161 13.161 0 01-2.789 6.657 12.878 12.878 0 01-5.886 4.171l-20.23 7.195a83.784 83.784 0 01-3.376 8.135l9.213 19.408a13.169 13.169 0 01-1.5 13.735l-12.4 12.4a13.179 13.179 0 01-13.738 1.5L159.88 197.7q-3.981 1.889-8.135 3.374l-7.173 20.252a13.37 13.37 0 01-4.173 5.884 13.075 13.075 0 01-6.658 2.79H116.3a13.155 13.155 0 01-6.657-2.79 12.879 12.879 0 01-4.173-5.884l-7.2-20.228a84.025 84.025 0 01-8.134-3.377l-19.406 9.212a13.179 13.179 0 01-13.737-1.5l-12.4-12.4a13.172 13.172 0 01-1.5-13.735l9.213-19.4a87.556 87.556 0 01-3.376-8.134l-20.254-7.22a13.344 13.344 0 01-5.884-4.171A13.068 13.068 0 0120 133.711v-17.466zm13.087 1.842a81.577 81.577 0 000 14.375l26.337 9.356.985 3.166a67.64 67.64 0 004.973 12.008l1.547 2.93-11.984 25.234a92.794 92.794 0 0010.178 10.177l25.236-11.983 2.931 1.55a67.466 67.466 0 0012.009 4.972l3.165.985 9.358 26.335c2.37.21 4.762.328 7.178.328s4.807-.118 7.176-.328l9.357-26.335 3.167-.985a67.487 67.487 0 0012.008-4.972l2.933-1.547 25.235 11.983a92.909 92.909 0 0010.181-10.177l-11.984-25.234 1.547-2.93a67.64 67.64 0 004.973-12.008l.984-3.166 26.335-9.356a81.77 81.77 0 000-14.375l-26.338-9.358-.984-3.165a67.36 67.36 0 00-4.973-11.982l-1.547-2.935 11.987-25.233a92.655 92.655 0 00-10.181-10.178l-25.235 11.984-2.933-1.549A67.628 67.628 0 00144.7 60.7l-3.167-.987-9.357-26.334c-2.369-.211-4.76-.329-7.176-.329s-4.808.118-7.178.329l-9.358 26.336-3.165.986a67.642 67.642 0 00-12.009 4.975l-2.931 1.549-25.236-11.986a92.54 92.54 0 00-10.178 10.178L66.929 90.65l-1.547 2.932a67.36 67.36 0 00-4.973 11.982l-.985 3.165zM125 95.738a29.548 29.548 0 11-29.551 29.548A29.549 29.549 0 01125 95.738m0-13.132a42.681 42.681 0 1042.685 42.681A42.68 42.68 0 00125 82.605z\"/></svg>";

var Sort = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M159.718 50.63l44.257 42.145a7.811 7.811 0 0010.648 0 6.9 6.9 0 00.247-9.851 8.126 8.126 0 00-.247-.244L157.528 28.3a7.789 7.789 0 00-10.61 0 6.95 6.95 0 00-2.152 4.38 3.368 3.368 0 00-.048.7v183.045a7.528 7.528 0 0015.038 0V50.63zM92.282 222.685l-56.9-54.9a7.06 7.06 0 01-.247-9.981c.08-.085.163-.167.247-.247a7.693 7.693 0 0110.61 0l44.218 42.7v-168a7.524 7.524 0 0115.038 0v185.485A7.4 7.4 0 0197.72 225a7.648 7.648 0 01-5.438-2.314z\"/></svg>";

var StarOutline = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M69.368 225.635a15.6 15.6 0 01-8.688-2.9 14.943 14.943 0 01-6.154-13.393l5.43-54.3-36.2-40.542a14.164 14.164 0 01-2.9-14.48 14.807 14.807 0 0110.86-9.774l53.217-11.582L112.445 31.6a13.888 13.888 0 0112.67-7.239 14.6 14.6 0 0112.67 7.239L165.3 78.664l53.214 11.584a14.232 14.232 0 0110.86 9.774 15.961 15.961 0 01-2.9 14.48l-36.2 40.544 5.43 54.3a14.943 14.943 0 01-6.154 13.393 14 14 0 01-14.48 1.448l-49.956-21.719-49.954 22.081a16.4 16.4 0 01-5.792 1.086zm55.346-37.312a15.007 15.007 0 015.792 1.086l49.956 22.082.362-.362-5.43-54.3a15.579 15.579 0 013.62-11.222l36.2-40.544v-.363L162 93.479a13.194 13.194 0 01-9.412-6.877l-27.512-47.06h-.362L97.2 86.6a13.932 13.932 0 01-9.411 6.877l-53.574 11.586v.362l36.2 40.544a14.14 14.14 0 013.62 11.222l-5.43 54.3.362.362 49.955-22.082a10.622 10.622 0 015.792-1.448z\"/></svg>";

var Star = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M69.368 225.635a15.6 15.6 0 01-8.688-2.9 14.943 14.943 0 01-6.154-13.393l5.43-54.3-36.2-40.542a14.164 14.164 0 01-2.9-14.48 14.807 14.807 0 0110.86-9.774l53.217-11.582L112.445 31.6a13.888 13.888 0 0112.67-7.239 14.6 14.6 0 0112.67 7.239L165.3 78.664l53.214 11.584a14.232 14.232 0 0110.86 9.774 15.961 15.961 0 01-2.9 14.48l-36.2 40.544 5.43 54.3a14.943 14.943 0 01-6.154 13.393 14 14 0 01-14.48 1.448l-49.956-21.719-49.954 22.081a16.4 16.4 0 01-5.792 1.086z\"/></svg>";

var Time = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125 20a105 105 0 10105 105A105 105 0 00125 20zm0 195a90 90 0 1190-90 90 90 0 01-90 90zm60.136-82.363a7.593 7.593 0 00-7.542-7.637H125V72.5a7.638 7.638 0 00-15.273 0v60.141a7.586 7.586 0 007.539 7.632h60.328a7.585 7.585 0 007.542-7.628z\"/></svg>";

var Topic = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M125.5 125.231h89.786V230H125.5z\"/><circle cx=\"125.043\" cy=\"125.043\" r=\"104.957\"/><path d=\"M102.831 89.021l4.724-28.893h15.628l-4.542 28.893h24.167l4.725-28.893h15.627l-4.543 28.893h16.355l-2.362 13.992h-16.174l-7.086 43.974h18.716L165.7 160.98h-18.53l-4.544 28.892h-15.809l4.543-28.892h-24.168l-4.543 28.892H86.84l4.543-28.892H75.028l2.363-13.993h16.173l7.087-43.974H81.934L84.3 89.021zm30.71 57.966l7.086-43.974h-24.168l-7.086 43.974z\" fill=\"#fff\"/></svg>";

var Trash = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 250 250\"><path d=\"M138.6 176.145V95.984c0-9.3 14-9.3 14 0v79.766c0 9.3-14 9.3-14 0m-41.984.4V96.011c0-9.292 14-9.292 14 0v79.712c0 9.292-14 9.292-14 0m83.036-115.269V46.267C179.652 34.521 170.4 25 159.221 25H90.2c-11.4 0-20.641 9.522-20.641 21.267v15.12h-33.8c-8.666 0-8.666 14 0 14h178.363c8.826 0 8.7-14.382-.122-14.382M83.554 47.081a7.233 7.233 0 016.912-7.153h69.419c3.676 0 6.705 2.907 6.705 7.153v14.306H83.554V47.392m89.567 177.269h-96.56a20.993 20.993 0 01-21-20.986V98.71a7.006 7.006 0 0113.995-.5q.009.249 0 .5v104.964a7.2 7.2 0 007 6.992h96.094a7.265 7.265 0 007-7.125V96.8c0-9.362 14-9.362 14 0v106.814c0 11.812-9.255 21.386-20.656 21.386\"/></svg>";

var script$1 = {
  name: 'sui-icon',
  mixins: [Mixin],
  props: {
    // 图标名称
    name: {
      type: String,
      required: true
    },
    // 填充颜色，可以是标准色号，也可以是具体颜色值
    fill: [String, Number]
  },
  computed: {
    style: function style() {
      var color = '';

      if (typeof this.fill == 'number') {
        color = this.mColor(this.fill);
      } else {
        color = this.fill ? this.fill : '#000';
      }

      return {
        'fill': color
      };
    }
  },
  data: function data() {
    return {
      icons: {
        'add-thin': AddThin,
        'add': Add,
        'arrow-back': ArrowBack,
        'arrow-down': ArrowDown,
        'arrow-dropdown': ArrowDropdown,
        'arrow-dropleft': ArrowDropleft,
        'arrow-dropright': ArrowDropright,
        'arrow-dropup': ArrowDropup,
        'arrow-forward': ArrowForward,
        'arrow-up': ArrowUp,
        'bad-outline': BadOutline,
        'bad': Bad,
        'bookmarks': Bookmarks,
        'calendar': Calendar,
        'check': Check,
        'close-circle': CloseCircle,
        'close-thin': CloseThin,
        'close': Close,
        'crown': Crown,
        'edit': Edit,
        'eye-outline': EyeOutline,
        'female-circle': FemaleCircle,
        'female': Female,
        'fire': Fire,
        'flag': Flag,
        'funnel-outline': FunnelOutline,
        'gift': Gift,
        'good-outline': GoodOutline,
        'good': Good,
        'group-circle': GroupCircle,
        'happy-outline': HappyOutline,
        'headset': Headset,
        'history': History,
        'home': Home,
        'letter': Letter,
        'loading': Loading,
        'male-circle': MaleCircle,
        'male': Male,
        'menu': Menu,
        'message-outline': MessageOutline,
        'message': Message,
        'paper': Paper,
        'picture-outline': PictureOutline,
        'pin-circle': PinCircle,
        'pin-outline': PinOutline,
        'play-circle-outline': PlayCircleOutline,
        'play': Play,
        'sad-outline': SadOutline,
        'search': Search,
        'setting': Setting,
        'sort': Sort,
        'star-outline': StarOutline,
        'star': Star,
        'time': Time,
        'topic': Topic,
        'trash': Trash
      }
    };
  }
};

var css$4 = ".sui-icon{font-size:0}.sui-icon svg{width:100%;height:100%}";
styleInject(css$4,{"insertAt":"top"});

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-icon",
    style: _vm.style,
    domProps: {
      innerHTML: _vm._s(_vm.icons[_vm.name])
    }
  });
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script$2 = {
  name: 'sui-image',
  components: {
    SuiIcon: __vue_component__$1
  },
  props: {
    // 图片路径
    src: {
      type: String,
      required: true
    },
    // 是否启用懒加载
    lazy: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0.06)'
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    // 是否展示加载动画
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      startLoad: false,
      // 是否开始加载
      loaded: false // 是否已加载完成

    };
  },
  computed: {
    // 图片协议转换为 https
    url: function url() {
      return this.src ? this.src.replace(/^(https?:)?\/\//g, 'https://') : '';
    },
    style: function style() {
      return {
        'background-image': "url(".concat(this.url, ")"),
        'background-size': this.backgroundSize
      };
    }
  },
  mounted: function mounted() {
    if (this.lazy && window.IntersectionObserver) {
      var self = this;
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0) {
          self.startLoad = true;
          this.disconnect();
        }
      });
      observer.observe(this.$el);
    } else {
      this.startLoad = true;
    }
  }
};

var css$5 = ".sui-image{display:flex;justify-content:center;align-items:center;width:100%;height:100%;overflow:hidden}.sui-image>.sui--container{flex:none;width:100%;height:100%;background-repeat:no-repeat;background-position:50%}.sui-image>.sui-icon{flex:none;-webkit-animation:rotate 1.5s linear infinite;animation:rotate 1.5s linear infinite}@media (orientation:portrait){.sui-image>.sui-icon{width:5.6vw;height:5.6vw}}@media (orientation:landscape){.sui-image>.sui-icon{width:3.148vw;height:3.148vw}}.sui-image>img{display:none}";
styleInject(css$5,{"insertAt":"top"});

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-image",
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, [_c("transition", {
    attrs: {
      name: "sui-animation--fade"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loaded,
      expression: "loaded"
    }],
    staticClass: "sui--container",
    style: _vm.style
  })]), _vm._v(" "), _vm.loading && !_vm.loaded ? _c("sui-icon", {
    attrs: {
      name: "loading",
      fill: 3
    }
  }) : _vm._e(), _vm._v(" "), _vm.startLoad ? _c("img", {
    attrs: {
      src: _vm.url
    },
    on: {
      "~load": function load($event) {
        _vm.loaded = true;
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
var script$3 = {
  name: 'sui-load',
  mixins: [Mixin],
  components: {
    SuiIcon: __vue_component__$1
  },
  props: {
    // 是否还有更多
    more: {
      type: Boolean,
      default: true
    },
    // 自定义主题色
    colors: {
      type: Object
    }
  }
};

var css$6 = ".sui-load{display:flex;justify-content:center;align-items:center;height:36px;font-size:12px}@media (max-aspect-ratio:1/2){.sui-load{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}@media (min-aspect-ratio:2/1){.sui-load{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}.sui-load .sui-icon{width:14px;height:14px;margin-right:3px;-webkit-animation:rotate 1s linear infinite;animation:rotate 1s linear infinite}@-webkit-keyframes rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}";
styleInject(css$6,{"insertAt":"top"});

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-load",
    style: {
      color: _vm.mColor(3)
    }
  }, [_vm.more ? [_c("sui-icon", {
    style: {
      fill: _vm.mColor(3)
    },
    attrs: {
      name: "loading"
    }
  }), _vm._v("加载中")] : _c("div", [_vm._v("— 我也是有底线的 —")])], 2);
};

var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var script$4 = {
  name: 'sui-popup',
  mixins: [Mixin],
  components: {
    SuiIcon: __vue_component__$1
  },
  data: function data() {
    return {
      show: false,
      title: '',
      content: '',
      options: [],
      button: '',
      colors: {},
      resolve: {},
      reject: {},
      index: -1
    };
  },
  watch: {
    'show': function show(nv) {
      if (!nv) {
        this.index = -1;
      }
    }
  },
  methods: {
    confirm: function confirm() {
      if (this.index < 0) {
        return;
      }

      this.show = false;
      this.resolve({
        option: this.options[this.index],
        index: this.index
      });
    },
    cancel: function cancel() {
      this.show = false;
      this.reject();
    },

    /**
     * 返回带透明度的颜色值
     * @param {Number} index - 配色规范色号
     */
    rgba: function rgba(index) {
      index = index.toString();
      var opacity = 1;

      switch (index) {
        case '2.1':
          opacity = 0.65;
          break;

        case '3.1':
          opacity = 0.5;
          break;

        case '8.1':
          opacity = 0.6;
          break;

        case '8.2':
          opacity = 0.3;
          break;

        case '15.1':
          opacity = 0.8;
          break;
      }

      var str = this.colors[index.split('.')[0]];
      return str.includes('#') ? "rgba(".concat(Number.parseInt(str.substr(1, 2), 16), ", ").concat(Number.parseInt(str.substr(3, 2), 16), ", ").concat(Number.parseInt(str.substr(5, 2), 16), ", ").concat(opacity, ")") : str.replace('1)', opacity + ')');
    }
  }
};

var css$7 = ".sui-popup>ul{position:fixed;bottom:0;left:0;z-index:110;width:100%;font-size:17px}.sui-popup>ul,.sui-popup>ul li{margin:0;padding:0}.sui-popup>ul .sui--title{display:flex;justify-content:space-between;align-items:center;height:45px;padding:0 15px;font-size:16px}.sui-popup>ul .sui--title .sui--icon{width:20px}.sui-popup>ul .sui--title:before{content:\"\";width:18px}.sui-popup>ul .sui--body{font-size:12px}@media (orientation:portrait){.sui-popup>ul .sui--body{padding:15px 30px}}@media (orientation:landscape){.sui-popup>ul .sui--body{padding:15px 86px}}.sui-popup>ul .sui--body .sui--options{display:flex;flex-wrap:wrap}.sui-popup>ul .sui--body .sui--options .sui--option{flex:none;display:flex;justify-content:center;align-items:center;height:36px;margin:15px 15px 0 0;border-radius:4px}@media (orientation:portrait){.sui-popup>ul .sui--body .sui--options .sui--option{width:calc((100% - 15px)/2)}}@media (orientation:landscape){.sui-popup>ul .sui--body .sui--options .sui--option{width:calc((100% - 45px)/4)}}@media (orientation:portrait){.sui-popup>ul .sui--body .sui--options .sui--option:nth-child(2n){margin-right:0}}@media (orientation:landscape){.sui-popup>ul .sui--body .sui--options .sui--option:nth-child(4n){margin-right:0}}.sui-popup>ul .sui--confirm{display:flex;justify-content:center;align-items:center;height:50px;border-top:10px solid;font-weight:500}@media (max-aspect-ratio:1/2){.sui-popup>ul .sui--confirm{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}@media (min-aspect-ratio:2/1){.sui-popup>ul .sui--confirm{padding-bottom:21px;padding-bottom:var(--safe-area-inset-bottom)}}.sui-popup>.sui--mask{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.6)}";
styleInject(css$7,{"insertAt":"top"});

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-popup"
  }, [_c("transition", {
    attrs: {
      name: "sui-animation--slide"
    }
  }, [_vm.show ? _c("ul", {
    style: {
      background: _vm.mColor(7)
    }
  }, [_c("li", {
    staticClass: "sui--title",
    style: {
      color: _vm.mColor(1),
      background: "linear-gradient(transparent, transparent 50%, " + _vm.mColor(8.1) + " 50%) repeat-x bottom / 1px 1px"
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c("sui-icon", {
    staticClass: "sui--icon",
    style: {
      fill: _vm.mColor(3)
    },
    attrs: {
      name: "close"
    },
    nativeOn: {
      click: function click($event) {
        return _vm.cancel($event);
      }
    }
  })], 1), _vm._v(" "), _c("li", {
    staticClass: "sui--body"
  }, [_c("div", {
    staticClass: "sui-style--ellipsis-2",
    style: {
      color: _vm.mColor(2)
    }
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c("div", {
    staticClass: "sui--options"
  }, _vm._l(_vm.options, function (item, i) {
    return _c("div", {
      key: item,
      staticClass: "sui--option",
      style: {
        color: _vm.index == i ? _vm.mColor(4) : _vm.mColor(2.1),
        background: _vm.mColor(10)
      },
      on: {
        touchstart: function touchstart($event) {
          _vm.index = i;
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0)]), _vm._v(" "), _c("li", {
    staticClass: "sui--confirm",
    style: {
      color: _vm.index >= 0 ? _vm.mColor(4) : _vm.mColor(3),
      "border-top-color": _vm.mColor(6)
    },
    on: {
      click: _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.button))])]) : _vm._e()]), _vm._v(" "), _c("transition", {
    attrs: {
      name: "sui-animation--fade-fast"
    }
  }, [_vm.show ? _c("div", {
    staticClass: "sui--mask",
    on: {
      click: _vm.cancel
    }
  }) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var PopupConstructor = Vue.extend(__vue_component__$4);
var instance$1 = new PopupConstructor().$mount();
/**
 * Popup
 * @param {Object} params - 参数对象
 * @param {String} params.title - 标题
 * @param {String} params.content - 内容文本
 * @param {Array} params.options - 选项
 * @param {String} [params.button='确定'] - 按钮文本
 * @param {Object} params.colors - 颜色
 * @returns {Object} Promise 对象
 */

function ActionSheetInstance$1(_ref) {
  var title = _ref.title,
      content = _ref.content,
      options = _ref.options,
      _ref$button = _ref.button,
      button = _ref$button === void 0 ? '确定' : _ref$button,
      colors = _ref.colors;
  return new Promise(function (resolve, reject) {
    instance$1.title = title.toString();
    instance$1.content = content.toString();
    instance$1.options = options;
    instance$1.button = button;
    instance$1.colors = colors;
    instance$1.resolve = resolve;
    instance$1.reject = reject;
    instance$1.show = true;
    document.body.appendChild(instance$1.$el);
  });
}

var script$5 = {
  name: 'sui-scroll',
  mixins: [Mixin],
  components: {
    SuiIcon: __vue_component__$1
  },
  props: {
    // 是否为水平滚动
    horizontal: {
      type: Boolean,
      default: false
    },
    // 是否开启下拉刷新
    pullDown: {
      type: Boolean,
      default: false
    },
    // 触发滚动到底部事件的距离
    onReachEndDistance: {
      type: Number,
      default: 200
    },
    // 内部容器类名
    containerClass: {
      type: String
    },
    // 内部容器样式
    containerStyle: {
      type: [Object, String]
    },
    // 自定义主题色
    colors: {
      type: Object
    }
  },
  data: function data() {
    return {
      // 当正在执行 touchstart 事件处理函数时锁定，避免因滑动过快导致未执行完即触发 touchomve 事件，导致触发全局滚动回弹
      lockTouchStart: false,
      touchStart: false,
      // 是否触发 touchStart 事件，MSDK BUG
      reachStart: false,
      // 是否滚动到起始端
      reachEnd: false,
      // 是否滚动到结束端
      originX: 0,
      // 触摸起始位置 X 坐标
      originY: 0,
      // 触摸起始位置 Y 坐标
      offset: 1,
      // 滚动判断非 px 单位容错量
      offsetY: 0,
      // 下拉状态的偏移位置
      threshold: 40,
      // 触发下拉刷新的偏移位置的阈值
      pullingDown: false,
      // 是否处于下拉状态
      isIOS: /Mac OS X/.test(navigator.userAgent),
      // 暂存上一次滚动位置，用于在 keep-alive 切换时恢复
      position: 0
    };
  },
  computed: {
    styleObj: function styleObj() {
      var obj = {
        'overflow-x': this.horizontal ? 'auto' : 'hidden',
        'overflow-y': !this.horizontal ? 'auto' : 'hidden'
      };
      return obj;
    },
    promptStyle: function promptStyle() {
      return {
        'height': "".concat(this.threshold, "px"),
        'color': this.mColor(3),
        'opacity': this.offsetY / this.threshold / 1.6
      };
    },
    iconStyle: function iconStyle() {
      return {
        'fill': this.mColor(3),
        'transform': "rotate(".concat(this.offsetY > this.threshold * 1.6 ? 180 : 0, "deg)")
      };
    }
  },
  activated: function activated() {
    if (this.horizontal) {
      this.$el.scrollLeft = this.position;
    } else {
      this.$el.scrollTop = this.position;
    }
  },
  methods: {
    /**
     * touchstart 事件
     * @param {Object} event - 事件对象
     */
    touchstartEvent: function touchstartEvent(event) {
      var _this = this;

      this.touchStart = true;
      this.lockTouchStart = true;
      var touch = event.targetTouches[0];
      this.originX = touch.clientX;
      this.originY = touch.clientY; // #region 竖向滚动

      if (this.horizontal) {
        this.lockTouchStart = false;
      } else {
        // #region 判断是否在起始端
        if (this.$el.scrollTop < this.offset) {
          this.offsetY = 0;
          this.pullingDown = false;
          this.$refs.container.style.transition = '';

          if (this.isIOS && !this.pullDown) {
            this.$el.scrollTop = this.offset;
          }

          this.reachStart = true;
          requestAnimationFrame(function () {
            _this.lockTouchStart = false;
          });
        } else {
          this.reachStart = false;
        } // #endregion
        // #region 判断是否在结束端


        if (this.$el.scrollHeight - this.$el.offsetHeight - this.$el.scrollTop < this.offset) {
          if (this.isIOS) {
            this.$el.scrollTop -= this.offset;
          }

          this.reachEnd = true;
          requestAnimationFrame(function () {
            _this.lockTouchStart = false;
          });
        } else {
          this.reachEnd = false;
        } // #endregion


        if (!this.reachStart && !this.reachEnd) {
          this.lockTouchStart = false;
        }
      } // #endregion

    },

    /**
     * touchmove 事件
     * @param {Object} event - 事件对象
     */
    touchmoveEvent: function touchmoveEvent(event) {
      var _this2 = this;

      this.touchStart = false;

      if (this.lockTouchStart) {
        return;
      }

      var touch = event.targetTouches[0];
      var offsetX = touch.clientX - this.originX;
      this.offsetY = touch.clientY - this.originY;

      if (this.horizontal) {
        // #region 阻止滚动：在横向滚动区域进行竖向滚动
        if (this.offsetY != 0 && Math.abs(offsetX / this.offsetY) < 1) {
          return;
        } // #endregion

      } else {
        if (this.pullDown) {
          if (this.reachStart && this.offsetY > 0) {
            this.pullingDown = true;
            requestAnimationFrame(function () {
              _this2.$refs.container.style.transform = "translate3d(0, ".concat(Number.parseInt(_this2.offsetY / 2), "px, 0)");
            });
          }

          if (this.reachStart && this.pullingDown) {
            return;
          }
        } else {
          // #region 阻止滚动：内容不够
          if (this.$el.scrollHeight - this.$el.offsetHeight < this.offset) {
            return;
          } // #endregion
          // #region 阻止滚动：非 IOS


          if (!this.isIOS) {
            if (this.reachStart && this.offsetY > 0 || this.reachEnd && this.offsetY < 0) {
              return;
            }
          } // #endregion

        }
      } // 阻止事件冒泡以触发局部滚动


      event.stopPropagation();
    },
    touchendEvent: function touchendEvent() {
      var _this3 = this;

      if (this.reachStart && this.pullDown && this.offsetY > 0) {
        requestAnimationFrame(function () {
          _this3.$refs.container.style.transition = "transform 500ms";
          _this3.$refs.container.style.transform = "translate3d(0, 0, 0)";
        });

        if (this.offsetY > this.threshold * 1.6) {
          this.$emit('refresh');
        }
      }
    },

    /**
     * scroll 事件
     * @param {Object} event - 事件对象
     */
    scrollEvent: function scrollEvent(event) {
      if (this.horizontal) {
        this.position = this.$el.scrollLeft;
        this.$emit('scroll', this.$el.scrollLeft, event);

        if (this.$el.scrollWidth - this.$el.offsetWidth - this.$el.scrollLeft < this.onReachEndDistance + this.offset) {
          this.$emit('reachEnd');
          this.$emit('reach-end');
        }
      } else {
        this.position = this.$el.scrollTop;
        this.$emit('scroll', this.$el.scrollTop, event);

        if (this.$el.scrollHeight - this.$el.offsetHeight - this.$el.scrollTop < this.onReachEndDistance + this.offset) {
          this.$emit('reachEnd');
          this.$emit('reach-end');
        }
      }
    }
  }
};

var css$8 = ".sui-scroll{-webkit-overflow-scrolling:touch}.sui-scroll>.sui--container{position:relative;min-height:100%}.sui-scroll>.sui--container .sui--pull-down{position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;font-size:12px;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}.sui-scroll>.sui--container .sui--pull-down .sui-icon{width:14px;height:14px;margin-right:4px;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.sui-scroll>.sui--container.sui--horizontal{display:flex;width:-webkit-max-content;width:max-content;height:100%}.sui-scroll>.sui--msdk{position:fixed;top:0;left:0;width:1px;height:1px}";
styleInject(css$8,{"insertAt":"top"});

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-scroll",
    style: _vm.styleObj,
    on: {
      touchstart: _vm.touchstartEvent,
      "&touchmove": function touchmove($event) {
        return _vm.touchmoveEvent($event);
      },
      touchend: _vm.touchendEvent,
      "&scroll": function scroll($event) {
        return _vm.scrollEvent($event);
      }
    }
  }, [_c("div", {
    ref: "container",
    staticClass: "sui--container",
    class: [_vm.containerClass, {
      "sui--horizontal": _vm.horizontal
    }],
    style: _vm.containerStyle
  }, [!_vm.horizontal && this.pullDown ? _c("div", {
    staticClass: "sui--pull-down",
    style: _vm.promptStyle
  }, [_c("sui-icon", {
    style: _vm.iconStyle,
    attrs: {
      name: "arrow-down"
    }
  }), _vm._v(_vm._s(this.offsetY > this.threshold * 1.6 ? "松开" : "下拉") + "刷新\n        ")], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.touchStart,
      expression: "touchStart"
    }],
    staticClass: "sui--msdk"
  })]);
};

var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  name: 'sui-swiper',
  props: {
    list: {
      type: Array,
      required: true
    },
    infinite: {
      type: Boolean,
      default: true
    },
    keyName: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    var currentIndex = this.infinite ? this.index + 1 : this.index;
    return {
      currentIndex: currentIndex,
      originX: 0,
      // 触摸起始位置 X 坐标
      threshold: 20,
      // 偏移量少于该值，不进行翻页
      translateX: "-".concat(currentIndex * 100 / this.list.length, "%"),
      transition: '',
      // 动画参数
      timer: 0
    };
  },
  computed: {
    styleUl: function styleUl() {
      return {
        'width': "".concat(this.list.length * 100, "%"),
        'transform': "translate3d(".concat(this.translateX, ", 0, 0)"),
        'transition': this.transition
      };
    },
    styleLi: function styleLi() {
      return {
        'width': "".concat(100 / this.list.length, "%")
      };
    }
  },
  methods: {
    /**
     * touchstart 事件
     * @param {Object} event - 事件对象
     */
    touchstartEvent: function touchstartEvent(event) {
      clearTimeout(this.timer);
      this.restore();
      var touch = event.targetTouches[0];
      this.originX = touch.clientX;
    },

    /**
     * touchmove 事件
     * @param {Object} event - 事件对象
     */
    touchmoveEvent: function touchmoveEvent(event) {
      var touch = event.targetTouches[0];
      var offsetX = touch.clientX - this.originX;
      this.translateX = "".concat(offsetX - this.currentIndex * this.$el.getBoundingClientRect().width, "px");
    },

    /**
     * touchend 事件
     * @param {Object} event - 事件对象
     */
    touchendEvent: function touchendEvent(event) {
      var touch = event.changedTouches[0];
      var offsetX = touch.clientX - this.originX;

      if (Math.abs(offsetX) > this.threshold) {
        if (offsetX > 0) {
          /* #region 上一页 */
          this.currentIndex -= 1;

          if (this.currentIndex < 0 && !this.infinite) {
            this.currentIndex = 0;
          }
          /* #endregion */

        } else {
          /* #region 下一页 */
          this.currentIndex += 1;

          if (this.currentIndex > this.list.length - 1 && !this.infinite) {
            this.currentIndex = this.list.length - 1;
          }
          /* #endregion */

        }
      }
      /* #region 动画执行 */


      var time = 500;
      this.transition = "transform ".concat(time, "ms");
      this.translateX = "-".concat(this.currentIndex * this.$el.getBoundingClientRect().width, "px");
      this.timer = setTimeout(this.restore.bind(this), time);
      /* #endregion */
    },

    /**
     * 首尾拼接
     */
    restore: function restore() {
      this.transition = '';

      if (this.infinite) {
        if (this.currentIndex == 0) {
          this.currentIndex = this.list.length;
        }

        if (this.currentIndex == this.list.length + 1) {
          this.currentIndex = 1;
        }
      }

      this.translateX = "-".concat(this.currentIndex * this.$el.getBoundingClientRect().width, "px");
      this.$emit('change', this.infinite ? this.currentIndex - 1 : this.currentIndex);
    }
  }
};

var css$9 = ".sui-swiper{overflow:hidden;width:100%;height:100%}.sui-swiper ul{display:flex;height:100%;margin:0;padding:0}.sui-swiper ul li{flex:none;height:100%;list-style-type:none}";
styleInject(css$9,{"insertAt":"top"});

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-swiper",
    on: {
      touchstart: _vm.touchstartEvent,
      "&touchmove": function touchmove($event) {
        return _vm.touchmoveEvent($event);
      },
      touchend: _vm.touchendEvent
    }
  }, [_c("ul", {
    style: _vm.styleUl
  }, [_vm.infinite ? _c("li", {
    style: _vm.styleLi
  }, [_vm._t("default", null, {
    item: _vm.list[_vm.list.length - 1]
  })], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.list, function (item) {
    return _c("li", {
      key: item[_vm.keyName],
      style: _vm.styleLi
    }, [_vm._t("default", null, {
      item: item
    })], 2);
  }), _vm._v(" "), _vm.infinite ? _c("li", {
    style: _vm.styleLi
  }, [_vm._t("default", null, {
    item: _vm.list[0]
  })], 2) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$7 = {
  name: 'sui-swiper-image',
  components: {
    SuiImage: __vue_component__$2,
    SuiSwiper: __vue_component__$6
  },
  data: function data() {
    return {
      show: false,
      images: [],
      keyName: '',
      infinite: false,
      index: 0,
      transitionName: 'sui-animation--fade-fast'
    };
  },
  computed: {
    currentIndex: function currentIndex() {
      return this.index + 1;
    }
  },
  watch: {
    'show': function show(nv) {
      if (nv) {
        history.pushState({}, '', '');
        window.addEventListener('popstate', this.popstateEvent);
      } else {
        window.removeEventListener('popstate', this.popstateEvent);
      }
    }
  },
  methods: {
    /**
     * 顺序变化
     * @param {Number} index - 最新的索引
     */
    changeSwiper: function changeSwiper(index) {
      this.index = index;
    },

    /**
     * 点击事件
     * @param {Object} item - 轮播项对象
     */
    clickEvent: function clickEvent(item) {
      history.back();
    },

    /**
     * 历史记录栈弹出事件处理函数
     */
    popstateEvent: function popstateEvent() {
      this.show = false;
    }
  }
};

var css$a = ".sui-swiper-image{position:fixed;top:0;left:0;z-index:99;width:100%;height:100%;background:#000}.sui-swiper-image>.sui--index{position:absolute;top:4%;left:5%;z-index:1;color:#fff}@media (orientation:portrait){.sui-swiper-image>.sui--index{font-size:4.267vw}}@media (orientation:landscape){.sui-swiper-image>.sui--index{font-size:2.399vw}}";
styleInject(css$a,{"insertAt":"top"});

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_vm.show ? _c("div", {
    staticClass: "sui-swiper-image"
  }, [_c("sui-swiper", {
    attrs: {
      list: _vm.images,
      infinite: _vm.infinite,
      "key-name": _vm.keyName,
      index: _vm.index
    },
    on: {
      change: _vm.changeSwiper
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var item = ref.item;
        return [_c("sui-image", {
          attrs: {
            loading: "",
            "background-size": "contain",
            src: item[_vm.keyName]
          },
          nativeOn: {
            click: function click($event) {
              return _vm.clickEvent(item);
            }
          }
        })];
      }
    }])
  }), _vm._v(" "), _c("div", {
    staticClass: "sui--index"
  }, [_vm._v(_vm._s(_vm.currentIndex) + "/" + _vm._s(_vm.images.length))])], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

/**
 * @file 图片查看器
 * @author hardylin <hardylin@tencent.com>
 */
var SwiperImageConstructor = Vue.extend(__vue_component__$7);
var instance$2 = new SwiperImageConstructor().$mount();
/**
 * SwiperImage
 * @param {Object} params - 参数对象
 * @param {Array} params.images - 包含图片 URL 的数据数组
 * @param {String} params.keyName - 图片字段名
 * @param {Boolean} [params.infinite=false] - 控制是否开启无限滑动效果
 * @param {Number} [params.index=0] - 设置组件初始化时默认为第几张，从 0 计数
 * @param {String} [params.transitionName='sui-animation--fade-fast'] - 图片查看器 打开 / 关闭 时的动画效果
 */

function SwiperImageInstance(_ref) {
  var _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      _ref$keyName = _ref.keyName,
      keyName = _ref$keyName === void 0 ? '' : _ref$keyName,
      _ref$infinite = _ref.infinite,
      infinite = _ref$infinite === void 0 ? false : _ref$infinite,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$transitionName = _ref.transitionName,
      transitionName = _ref$transitionName === void 0 ? 'sui-animation--fade-fast' : _ref$transitionName;
  instance$2.images = images;
  instance$2.keyName = keyName;
  instance$2.infinite = infinite;
  instance$2.index = index;
  instance$2.transitionName = transitionName;
  instance$2.show = true;
  document.body.appendChild(instance$2.$el);
}

//
var script$8 = {
  name: 'sui-switch',
  mixins: [Mixin],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean,
    // 自定义主题色
    colors: {
      type: Object
    }
  },
  computed: {
    styleOutter: function styleOutter() {
      return this.value ? {
        'border-color': this.mColor(4),
        'background': this.mColor(4)
      } : {
        'border-color': this.mColor(8)
      };
    },
    styleInner: function styleInner() {
      return this.value ? {
        'border-width': 0,
        'box-shadow': 'none'
      } : {
        'border-color': this.mColor(8.1)
      };
    }
  },
  methods: {
    toggle: function toggle(event) {
      event.stopPropagation();
      this.$emit('change', !this.value);
    }
  }
};

var css$b = ".sui-switch{flex:none;display:inline-flex;align-items:center;box-sizing:border-box;border-style:solid;transition-property:border-color,background;transition-duration:.16s;transition-timing-function:cubic-bezier(.33,0,.66,1)}@media (orientation:portrait){.sui-switch{width:10.133vw;height:6.133vw;border-width:.133vw;border-radius:3.067vw}}@media (orientation:landscape){.sui-switch{width:5.697vw;height:3.448vw;border-width:.075vw;border-radius:1.724vw}}.sui-switch .sui--circle{box-sizing:border-box;border-style:solid;border-radius:50%;background:#fff;transition-property:border-width,border-color,box-shadow,-webkit-transform;transition-property:border-width,border-color,box-shadow,transform;transition-property:border-width,border-color,box-shadow,transform,-webkit-transform;transition-duration:.256s;transition-timing-function:cubic-bezier(.33,0,.1,1)}@media (orientation:portrait){.sui-switch .sui--circle{width:5.6vw;height:5.6vw;border-width:.133vw;box-shadow:0 0 1.333vw rgba(0,0,0,.2)}}@media (orientation:landscape){.sui-switch .sui--circle{width:3.148vw;height:3.148vw;border-width:.075vw;box-shadow:0 0 .75vw rgba(0,0,0,.2)}}@media (orientation:portrait){.sui-switch.sui--on .sui--circle{-webkit-transform:translate3d(4vw,0,0);transform:translate3d(4vw,0,0)}}@media (orientation:landscape){.sui-switch.sui--on .sui--circle{-webkit-transform:translate3d(2.249vw,0,0);transform:translate3d(2.249vw,0,0)}}";
styleInject(css$b,{"insertAt":"top"});

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-switch",
    class: {
      "sui--on": _vm.value
    },
    style: _vm.styleOutter,
    on: {
      click: function click($event) {
        return _vm.toggle($event);
      }
    }
  }, [_c("div", {
    staticClass: "sui--circle",
    style: _vm.styleInner
  })]);
};

var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
var script$9 = {
  name: 'sui-toast',
  data: function data() {
    return {
      show: false,
      // 显示控制
      content: '' // 提示内容

    };
  }
};

var css$c = ".sui-toast{z-index:999;position:fixed;top:50%;left:50%;display:flex;justify-content:center;align-items:center;border-radius:4px;padding:12px 18px;font-size:14px;color:#fff;background:rgba(0,0,0,.8);-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}";
styleInject(css$c,{"insertAt":"top"});

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "sui-animation--fade"
    }
  }, [_vm.show ? _c("div", {
    staticClass: "sui-toast"
  }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()]);
};

var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var ToastConstructor = Vue.extend(__vue_component__$9); // toast 实例栈

var toastStack = [];

function getAnInstance() {
  if (toastStack.length > 0) {
    return toastStack.pop();
  }

  return new ToastConstructor().$mount();
}
/**
 * Toast 提示
 * @param {String} content - 提示内容
 */


function ToastInstance(content) {
  var instance = getAnInstance();
  clearTimeout(instance.timer);
  instance.content = content.toString();
  instance.show = true;
  document.body.appendChild(instance.$el);
  instance.timer = setTimeout(function () {
    instance.show = false;
    toastStack.push(instance);
  }, 3000);
}

var script$a = {
  name: 'sui-waterfall',
  components: {
    SuiScroll: __vue_component__$5
  },
  props: {
    // 竖屏列数
    portrait: {
      type: Number,
      default: 1
    },
    // 横屏列数
    landscape: {
      type: Number,
      default: 2
    },
    keyName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      data: [],
      // 原始数据
      renderData: [] // 分割后实际用于渲染的数据

    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.init);
  },
  methods: {
    /**
     * 重置瀑布流
     * @param {Array} data - 瀑布流初始数据
     */
    reset: function reset(data) {
      this.data = data;
      this.init();
    },

    /**
     * 追加数据
     * @param {Array} data - 原始对象数组
     */
    appendData: function appendData(data) {
      this.data = this.data.concat(data);

      if (this.renderData.length > 1) {
        this.render(data);
      } else {
        this.renderData = [this.renderData[0].concat(data)];
      }
    },

    /**
     * 删除某条数据
     * @param {Number} col - 数据所在的列
     * @param {Number} index - 数据在其列中的索引
     */
    delete: function _delete(col, index) {
      this.$delete(this.renderData[col], index);
    },
    init: function init() {
      var column = window.innerWidth == Math.min(screen.width, screen.height) ? this.portrait : this.landscape;

      if (column > 1) {
        this.renderData = [];

        for (var i = 0; i < column; i++) {
          this.$set(this.renderData, i, []);
        }

        this.render();
      } else {
        this.renderData = [this.data];
      }
    },

    /**
     * 渲染多列数据
     * @param {Array} data - 原始对象数组
     */
    render: function render() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.data;

      if (data.length < 1) {
        return;
      }

      var index = 0;
      appendItem.call(this);

      function appendItem() {
        var _this = this;

        this.$nextTick(function () {
          var minIndex = 0;

          for (var i = 1; i < _this.$refs.pipe.length; i++) {
            if (_this.$refs.pipe[i].clientHeight < _this.$refs.pipe[minIndex].clientHeight) {
              minIndex = i;
            }
          }

          _this.renderData[minIndex].push(data[index]);

          if (data.length > ++index) {
            appendItem.call(_this);
          }
        });
      }
    }
  }
};

var css$d = ".sui-waterfall{display:flex;align-items:start}.sui-waterfall ul{margin:0;padding:0}.sui-waterfall ul li{margin:0;padding:0;list-style-type:none}";
styleInject(css$d,{"insertAt":"top"});

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sui-waterfall"
  }, _vm._l(_vm.renderData, function (list, col) {
    return _c("ul", {
      key: col,
      ref: "pipe",
      refInFor: true,
      style: {
        width: "calc(100% / " + _vm.renderData.length + ")"
      }
    }, _vm._l(list, function (item, index) {
      return _c("li", {
        key: item[_vm.keyName]
      }, [_vm._t("default", null, {
        item: item,
        col: col,
        index: index
      })], 2);
    }), 0);
  }), 0);
};

var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

/**
 * @file 入口文件
 * @author hardylin <hardylin@tencent.com>
 */
/**
 * Vue 插件安装方法
 * @param {Object} Vue - Vue 类
 */

function install(Vue) {
  // #region 自定义组件
  Vue.component(__vue_component__$1.name, __vue_component__$1);
  Vue.component(__vue_component__$2.name, __vue_component__$2);
  Vue.component(__vue_component__$3.name, __vue_component__$3);
  Vue.component(__vue_component__$5.name, __vue_component__$5);
  Vue.component(__vue_component__$6.name, __vue_component__$6);
  Vue.component(__vue_component__$8.name, __vue_component__$8);
  Vue.component(__vue_component__$a.name, __vue_component__$a); // #endregion
  // #region 实例方法

  Vue.prototype.$actionSheet = ActionSheetInstance;
  Vue.prototype.$popup = ActionSheetInstance$1;
  Vue.prototype.$swiperImage = SwiperImageInstance;
  Vue.prototype.$toast = ToastInstance; // #endregion
} // #region 自动安装


if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
} // #endregion


var index = {
  install: install,
  version: version,
  config: config
};

export default index;
export { ActionSheetInstance as ActionSheet, __vue_component__$1 as Icon, __vue_component__$2 as Image, __vue_component__$3 as Load, ActionSheetInstance$1 as Popup, __vue_component__$5 as Scroll, __vue_component__$6 as Swiper, SwiperImageInstance as SwiperImage, __vue_component__$8 as Switch, ToastInstance as Toast, config, version };
